import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactoryResolver, Input, OnInit, Pipe, ViewChild, ViewContainerRef } from '@angular/core';
import jsPDF from 'jspdf';
import { CaratteriInfoService, IFontStile } from './caratteri-info.service.js';
import { ModelloStampaItem } from '../../services/modelli-stampa.service';
import { DxButtonGroupComponent, DxContextMenuComponent, DxDataGridComponent, DxListComponent, DxNumberBoxComponent } from 'devextreme-angular';
import {replaceObject,removeObject, insertObjectAfter, insertObjectBefore} from 'find-and';
//import { mockData } from './test';
import { Categorie, IModelloStampa, ModelliStampaService } from '../../services/modelli-stampa.service';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.js';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { DistinctArrayPipe } from '../../components/shared/distinct-array.pipe.js';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { v4 as uuidv4 } from 'uuid';
import { ComponentService } from '../../services/component.service.js';
import { NicaMainMenuComponent } from '../../layout/nica-main-menu/nica-main-menu.component.js';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component.js';
import { saveAs } from 'file-saver';
//import { QRCode,toDataURL } from 'qrcode';



const interact = require('interactjs');

const segnaPostiVariabile = "###############################################################################################################################################################################################################################################################";


//https://www.convert-measurement-units.com/conversion-calculator.php CM->PX 

export interface ICoordinateObj {
  x: number;
  y: number;
}

@Pipe({
  name: 'dashCase'
})


@Component({
  selector: 'app-nica-modello-stampa',
  templateUrl: './nica-modello-stampa.component.html',
  styleUrls: ['./nica-modello-stampa.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush
})

export class NicaModelloStampaComponent extends NicaMaster implements OnInit, AfterViewChecked  {

  //Interrogo le mie template variables
  @ViewChild("menuContestualeFoglio", { read: false, static: false }) menuContestualeFoglio: DxContextMenuComponent;
  @ViewChild("gruppoBottoniAspetto", { read: false, static: false }) gruppoBottoniAspetto: DxButtonGroupComponent;
  @ViewChild("gruppoBottoniAllineamento", { read: false, static: false }) gruppoBottoniAllineamento: DxButtonGroupComponent;
  @ViewChild("fileManagerDinamico", { static: false, read: ViewContainerRef }) fileManagerDinamico: ViewContainerRef;
  @ViewChild('dxListaVariabili',{static:false}) dxListaVariabili : DxListComponent;
  //@ViewChild('formSalvataggioModello',{static:false}) formSalvataggioModello : NicaFormComponent; Avvisi di Circular Dependency perché presente anche in NicaAnagraficaComponent
  @ViewChild('datagridModelliStampa',{static:false}) datagridModelliStampa : DxDataGridComponent;
  //@ViewChild(DxListComponent,{static:false,read:true}) dxListaKeys : DxListComponent;
  


  @Input() idCategoria? : string; 



  constructor(private caratteriInfo: CaratteriInfoService, private cdr: ChangeDetectorRef, public modelliStampaService:ModelliStampaService,private http:HttpClient,private resolver: ComponentFactoryResolver,private componentService:ComponentService) {
    super();
  }


  altezzaHeader: number = 0;
  altezzaFooter: number = 0;
  altezzeFont: number[];
  famiglieFont: string[];
  allineamentiFont: IFontStile[];
  aspettiFont: IFontStile[];

  maxLunghezzaCaratteri?:number;

  coordinateNuovoElemento: ICoordinateObj;
  foglio?: HTMLElement;
  displayPos: string;
  popupProprietaVisibile: boolean;
  isMenuContestualeItemAperto: boolean = false;
  itemsArray: ModelloStampaItem[]; //Gli elementi che verranno poi stampati nel pdf
  itemSelezionato : ModelloStampaItem;
  itemsSelezionati : ModelloStampaItem[] = [];
  //itemsArrayDistinct : ModelloStampaItem[] = [];
  itemCopiato : ModelloStampaItem;
  stoModificando: boolean = false;
  dataTable:any[]=[];
  fileManagerVisibile: boolean = false;
  pdf: jsPDF;
  isDragging: boolean = false;
  stoCaricandoModello : boolean = false
  isSelectingMuliple:boolean=false;
  variabiliDS?: DataSource;
  variabiliSelezionate: string[] = [];
  popupListaVariabili: boolean = false;
  containerAttuale?: ModelloStampaItem; //Serve per il drop out delle variabili da un cornice
  coloreMultiselezione:string='rgba(245, 144, 39, 0.66)';
  zIndexIncrementale:number=0;
  @Input() modelloDiStampaCaricato?:IModelloStampa;
  @Input() ODataQueryString?:string;
  immagineDiSfondoCaricata?:string; //B64 Immagine di Sfondo
  modelliDiStampaDS:IModelloStampa[]=[];
  lookupCategoriaModelli:any[];
  mostraPopupSalvataggioModello:boolean=false;
  mostraPopupModelliCaricati:boolean=false;
  apriTuttiForms:boolean =  false;

 
  buttonCustom = [
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Salva',
      icon: "glyphicon mdi mdi-content-save-outline",
      event: 'salvaModello',
    }
  ];


  tooltipSliderImportaVariabili = {
    enabled: true,
    format: (value) => this.formatta(value),
    showMode: 'always', //onHover
    position: 'top',
  };

  tooltipSlider = {
    enabled: true,
    format: (value) => this.formatta(value),
    showMode: 'always', //onHover
    position: 'bottom',
  };

  formatta(valore){

    //console.warn(valore);

    return `${valore == 0 ? 1 : valore} Caratteri`;
  }

  pulsanteModificaFormOptions={
    text:'Carica',
    type:'normal',
    icon:'save',
    onClick:()=>{
      if(this.datagridModelliStampa.instance.getSelectedRowKeys()[0]['id']){

        if(this.modelloDiStampaCaricato == undefined && this.itemsArray.length==0){

          this.caricaModello(this.datagridModelliStampa.instance.getSelectedRowKeys()[0]['id']);

          return;
        }

        let confirmDialog = confirm(`<i>Sei sicuro di voler caricare il modello '${this.datagridModelliStampa.instance.getSelectedRowKeys()[0]['nomeModello']}'?</i>
        <br><b>Le modifiche non salvate andranno perse</b>`,'Caricamento Modello');
        
        confirmDialog.then((dialogResult) => {
            //alert(dialogResult ? "Confirmed" : "Canceled");
    
          if(!dialogResult)
            return;
    
            this.caricaModello(this.datagridModelliStampa.instance.getSelectedRowKeys()[0]['id']);
            
        });

      }
    }
  }

  coloriDefaultArray: any[] = [
    {
      color: "#ffffff",
      transparency: false
    },
    {
      color: "#000000",
      transparency: false
    },
    {
      color: "#c0c0c0",
      transparency: false
    },
    {
      color: "#0000ff",
      transparency: false
    },
    {
      color: "#00ff00",
      transparency: false
    },
    {
      color: "#ff0000",
      transparency: false
    },
    {
      color: "#00ffff",
      transparency: false
    },
    {
      color: "#ffff00",
      transparency: false
    },
    {
      color: "#ff00ff",
      transparency: false
    },
    {
      color: "#f6f6f6", //Trasparenza
      transparency: true
    }
  ]

  formDataProprieta : any = {
    tipo: "",
    valore: "",
    coloreSfondo: "",
    coloreTesto: "",
    coloreBordo: "",
    stileBordo: "solid",
    altezzaFont: 9,
    rangeCaratteri : {
      inizio:0,fine:255
    },
    famigliaFont: "Helvetica",
    allineamentoFont: "l",
    aspettoFont: {
      bold: false,
      italic: false,
      underline: false,
      strike: false
    },
  };

  menuContestualeItems: any[] = [
    {
      text: 'Crea Oggetto',
      icon: 'add',
      items: [
        { text: 'Variabile' },
        { text: 'Testo' },
        { text: 'Cornice', beginGroup: true },
        { text: 'Linea Verticale'},
        { text: 'Linea Orizzontale'},
        { text: 'Immagine', beginGroup: true },
      ],
    },
    { text: 'Copia', beginGroup: true, disabled: true },
    { text: 'Taglia', disabled: true },
    { text: 'Elimina', disabled: true },
    { text: 'Incolla', disabled: true },
    { text: 'Proprietà', beginGroup: true, disabled: true },
  ];


  menuContestualeItemSingolo: any[] = [
    {
      text: 'Crea Oggetto',
      disabled: true,
      icon: 'add',
      items: [
        { text: 'Variabile', disabled: false },
        { text: 'Testo' },
        { text: 'Cornice', beginGroup: true },
        { text: 'Linea Verticale', disabled: true },
        { text: 'Linea Orizzontale', disabled: true },
        { text: 'Immagine', beginGroup: true },
      ],
    },
    { text: 'Copia', beginGroup: true},
    { text: 'Taglia', disabled: true },
    { text: 'Elimina' },
    { text: 'Incolla', disabled: true },

    {
      text: 'Allinea',
      disabled: true,
      beginGroup: true,
      icon: 'alignjustify',
      items: [
        { text: 'Allinea Bordi Superiori'},
        { text: 'Allinea Bordi Inferiori'},

        { text: 'Allinea Bordi a Sinistra'},
        { text: 'Allinea Bordi a Destra'},

      ],
    },

   
    { text: 'Proprietà', beginGroup: true },
  ];

  onClickPulisciFoglio(){

    let confirmDialog = confirm("<i>Sei sicuro di voler pulire il foglio?</i><br><b>Le modifiche non salvate andranno perse</b>", "Pulizia Foglio");
    confirmDialog.then((dialogResult) => {
        //alert(dialogResult ? "Confirmed" : "Canceled");

      if(!dialogResult)
        return;

        let items = JSON.parse(JSON.stringify(this.itemsArray)); //Per qualche arcano motivo non mi prende tutti i valori per la cancellazione quindi faccio questa operazione

        for(let item of items){

          //console.log(item);

          this.deleteItemByID(item.id.toString());

        }

        this.zIndexIncrementale = 10;
    });
  }

  async onClickAggiornaModello(){

    let confirmDialog = confirm("<i>Sei sicuro di voler salvare il modello?</i>", "Salvataggio Modello");
    confirmDialog.then( async (dialogResult) => {
        //alert(dialogResult ? "Confirmed" : "Canceled");

      if(!dialogResult)
        return;

        const innerHTML: string =document.getElementById('foglio').innerHTML;
        const itemsSalvati: string = JSON.stringify(this.itemsArray);
    
        let modelloDiStampa : IModelloStampa={
          id:(this.modelloDiStampaCaricato) ? this.modelloDiStampaCaricato.id : undefined,
          nomeModello:this.modelloDiStampaCaricato.nomeModello, //this.formSalvataggioModello.dataSet['nomeModello'],
          idCategoriaModello:this.modelloDiStampaCaricato.idCategoriaModello,   //this.formSalvataggioModello.dataSet['categoriaModello'][this.formSalvataggioModello.dataSet['categoriaModello'].length-1]['id'],
          htmlText:innerHTML,
          json:itemsSalvati,
          formato:this.modelloDiStampaCaricato.formato,   //this.formSalvataggioModello.dataSet['formato'],
          orientamento:this.modelloDiStampaCaricato.orientamento,   //this.formSalvataggioModello.dataSet['orientamento'],
          guidCreazione:this.modelloDiStampaCaricato.guidCreazione
        }; 
    
        
    
          let ris = await this.modelliStampaService.aggiornaModello(modelloDiStampa,modelloDiStampa.id);
    
          if(ris){
    
            this.modelloDiStampaCaricato = ris;
    
            notify({
              message:  `Modello di Stampa '${this.modelloDiStampaCaricato.nomeModello}' aggiornato con successo!`,
              position: {
                my: "center bottom",
                at: "center bottom"
              }
            }, "success", 3000);
                 
         }        
    
        this.modelliDiStampaDS=await this.modelliStampaService.getModelli();
        this.mostraPopupSalvataggioModello=false;
    
        /*
        this.mostraPopupSalvataggioModello=true;
    
        if(this.modelloDiStampaCaricato)
         setTimeout(
          async ()=>{
    
            let categoriaModello = await this.modelliStampaService.getCategoriaModelloById(this.modelloDiStampaCaricato.idCategoriaModello)
    
            console.warn(categoriaModello)
    
            this.formSalvataggioModello.formEdit.instance.updateData('nomeModello',this.modelloDiStampaCaricato.nomeModello);
            this.formSalvataggioModello.formEdit.instance.updateData('categoriaModello',[categoriaModello]);
    
    
          },200
        )
        */
    
    

    });

    


  }

  async aggiornaModello(evt){

    //console.warn(evt['data']);

    let modelloDaAggiornare = await this.modelliStampaService.getModelloById(evt['data']['id']);


    if(modelloDaAggiornare){


      modelloDaAggiornare.nomeModello = evt['data']['nomeModello'];
      modelloDaAggiornare.formato = evt['data']['formato'];
      modelloDaAggiornare.orientamento = evt['data']['orientamento'];
      modelloDaAggiornare.idCategoriaModello = evt['data']['idCategoriaModello'];
      

      await this.modelliStampaService.aggiornaModello(modelloDaAggiornare,evt['data']['id']);

      await this.datagridModelliStampa.instance.refresh();
    }



  }

  /** Metodo che controlla se l'elemento html abbia un elemetno bordoTrascianamento interno, se no lo aggiunge e lo gestisce */
  manipolaElemento(elemento: HTMLElement): void {

    let bordoTrascinamento: HTMLDivElement = document.createElement('div');


    let elementoCliccatoId = elemento.id;

    bordoTrascinamento.id = "bordoTrascinamento-".concat(elementoCliccatoId);
    bordoTrascinamento.className = "bordiTrascinamento";

    
    bordoTrascinamento.style.width = "90%";
    bordoTrascinamento.style.height = "100%";
    
      

    //bordoTrascinamento.style.border="1px solid black";
    //bordoTrascinamento.style.borderStyle="dashed";

    bordoTrascinamento.style.margin = "0";

    //bordoTrascinamento.style.transform = `translate(0px,-${(elemento.offsetHeight)/2}px)`;
    bordoTrascinamento.style.position = "absolute";
    bordoTrascinamento.style.top = "50%";
    bordoTrascinamento.style.left = "50%";
    bordoTrascinamento.style.transform = "translate(-50%, -50%)";
    bordoTrascinamento.style.cursor = "grab";

    //elemento.style.overflow = "hidden";
    //elemento.style.resize = "horizontal";

    /*
    
  */

    

    if (!elemento.contains(document.getElementById("bordoTrascinamento-".concat(elementoCliccatoId))) && elemento.id !== 'areaHeader' && elemento.id !== 'areaFooter' && elemento.id !== 'canvasAppoggio' && elemento.id !== 'divSfondoFoglio') {


      elemento.appendChild(bordoTrascinamento);


    }

    if (elemento.id !== 'areaHeader' && elemento.id !== 'areaFooter' && elemento.id !== 'canvasAppoggio' && elemento.id !== 'divSfondoFoglio')
      this.dragElement(elemento);
    /*
       Procudura per il vecchio Ridimensionatore
   
       let ridimensionatore = document.createElement("div");
       ridimensionatore.style.width="fit-content";
       ridimensionatore.style.height="fit-content";
       ridimensionatore.style.position="absolute";
       ridimensionatore.style.right="0";
       ridimensionatore.style.bottom="50%";
       ridimensionatore.style.marginRight="-15px";
       ridimensionatore.style.backgroundColor="lightgrey";
       ridimensionatore.style.color="white";
       ridimensionatore.style.transform="translate(0px,50%)";
       ridimensionatore.style.cursor="w-resize";
   
       ridimensionatore.id="ridimensionatore-".concat(elemento.id);
       ridimensionatore.innerHTML="<i class='fas fa-arrow-right'></i>"
   
   
       if(!bordoTrascinamento.contains(document.getElementById(ridimensionatore.id)))
         bordoTrascinamento.appendChild(ridimensionatore);
   
       //ridimensionatore.addEventListener('mousedown', iniziaRidimensionamento, false);
       ridimensionatore.addEventListener("mousedown",initDrag,false);
   
       var startX,startY,startWidth,startHeight;
   
       function initDrag(e) {
         
         startX = e.clientX;
         startY = e.clientY;
         startWidth = parseInt(document.defaultView.getComputedStyle(bordoTrascinamento).width, 10);
         startHeight = parseInt(document.defaultView.getComputedStyle(bordoTrascinamento).height, 10);
         document.documentElement.addEventListener('mousemove', doDrag, false);
         document.documentElement.addEventListener('mouseup', stopDrag, false);
     
      }
      
      function doDrag(e) {
   
         //console.log({startX,startY,startWidth,startHeight});
    
         bordoTrascinamento.style.width = (startWidth + e.clientX - startX) + 'px';
   
         elemento.style.width = (startWidth + e.clientX - startX) + 'px';
         
       
         //bordoTrascinamento.style.height = (startHeight + e.clientY - startY) + 'px';
      }
      
      function stopDrag(e) {
   
   
          document.documentElement.removeEventListener('mousemove', doDrag, false);
          document.documentElement.removeEventListener('mouseup', stopDrag, false);
      
      }
      */






    /*
    let observer = new ResizeObserver(function(mutations) {
      console.log('mutations:', mutations);

      if(mutations[0].contentRect)

    })
    observer.observe(elemento);
    
    
    

    for(let i = 0;i<document.getElementsByClassName("items").length;i++){

      if(document.getElementsByClassName("items").item(i).id!== elemento.id && document.getElementById("bordoTrascinamento-".concat(document.getElementsByClassName("items").item(i).id))){
        document.getElementById("bordoTrascinamento-".concat(document.getElementsByClassName("items").item(i).id)).remove();
      }

    }

    
  */



  }


  resetFormData(): void {

    this.formDataProprieta.tipo = "";
    this.formDataProprieta.altezzaFont = 9;
    this.formDataProprieta.famigliaFont = "Helvetica";
    this.formDataProprieta.coloreSfondo = "";
    this.formDataProprieta.coloreTesto = "";
    this.formDataProprieta.coloreBordo = "";
    this.formDataProprieta.stileBordo = "solid";
    this.formDataProprieta.valore = "";
    this.formDataProprieta.aspettoFont.bold = false;
    this.formDataProprieta.aspettoFont.italic = false;
    this.formDataProprieta.aspettoFont.strike = false;
    this.formDataProprieta.aspettoFont.underline = false;
    this.formDataProprieta.rangeCaratteri ={
      inizio:0,fine:255
    }

    if (this.gruppoBottoniAllineamento && this.gruppoBottoniAllineamento) {
      this.gruppoBottoniAspetto.selectedItems = [];
      this.gruppoBottoniAllineamento.selectedItems = [];
    }

  }

  convertiDaPxACm(pixels: number): number {
    return parseFloat(((pixels * 0.264583) / 10).toFixed(2)); //Massimo numero di cifre decimali
  }

  convertiDaPtACm(points: number): number {
    return parseFloat(((points * 0.035277) * 10).toFixed(2));
  }


  async ngOnInit() {

    
    const t = this;
    
    this.zIndexIncrementale = 10; 

    this.altezzeFont = this.caratteriInfo.getAltezzeFont();
    this.famiglieFont = this.caratteriInfo.getFamiglieFont();
    this.allineamentiFont = this.caratteriInfo.getAllineamenti();
    this.aspettiFont = this.caratteriInfo.getAspetti();


    this.modelliDiStampaDS=await this.modelliStampaService.getModelli();
    this.lookupCategoriaModelli = await this.modelliStampaService.getCategorieModelli();

    this.popupProprietaVisibile = false;
    this.foglio = document.getElementById("foglio");
    this.displayPos = "";
    this.itemsArray = [];
    this.zIndexIncrementale=0;


    //console.log(this.dataTable);


    this.itemSelezionato = {
      id: undefined,
      contenuto: undefined,
      posizione: undefined,
      tipo: undefined
    }


    //SOLO LA PRIMA VOLTA VIENE APPLICATO IL BIND LE VOLTE SUCCESSIVE VIENE IGNORATO
    this.muoviCursoreSuFoglio = this.muoviCursoreSuFoglio.bind(this);  //Il bind(this) permette di accedere alle proprietà di questa classe/componente
    this.onKeyUpAggiornaTipo = this.onKeyUpAggiornaTipo.bind(this);
    this.gestisciCRUD = this.gestisciCRUD.bind(this);
    this.aggiornaAltezzaHeader = this.aggiornaAltezzaHeader.bind(this);
    this.aggiornaAltezzaFooter = this.aggiornaAltezzaFooter.bind(this);
    this.onClickPulisciFoglio = this.onClickPulisciFoglio.bind(this);
    this.onValueChangedRangeCaratteri = this.onValueChangedRangeCaratteri.bind(this);

   

    let areaFooter = document.createElement('div');
    areaFooter.id = 'areaFooter';
    areaFooter.style.backgroundColor = 'rgba(158, 255, 49, 0.45)';
    areaFooter.style.position = 'absolute';
    areaFooter.style.width = '100%';
    areaFooter.style.height = '0cm';
    areaFooter.style.bottom = '0';

    let areaHeader = document.createElement('div');
    areaHeader.style.backgroundColor = 'rgba(158, 255, 49, 0.45)';
    areaHeader.style.position = 'absolute';
    areaHeader.style.width = '100%';
    areaHeader.style.height = '0cm';
    areaHeader.style.top = '0';
    areaHeader.id = 'areaHeader';


    document.getElementById('foglio').appendChild(areaFooter);
    document.getElementById('foglio').appendChild(areaHeader);

 
    
    this.inizializzaRettangoloDiSelezione();

    this.foglio.addEventListener("mousemove", this.muoviCursoreSuFoglio);//Il this passa al metodo(o funzione in questo caso) il MouseEvent

    this.foglio.onmouseleave = function () {


      t.displayPos = "";

    }

    this.foglio.addEventListener("contextmenu",
      (e) => {
        e.preventDefault(); //evito che appaia il classico menù contestuale del browser 

        this.foglio.removeEventListener("mousemove", this.muoviCursoreSuFoglio);

        const { clientX: mouseX, clientY: mouseY } = e;



        this.displayPos = "";

        if ((e.target as HTMLElement).id.toLowerCase() == 'foglio'){

          console.log('spipposssssss');

          this.itemSelezionato = undefined;
          this.rimuoviElementiSelezionati();

        }


        /*
        Vado a bloccare lo scroll nel punto in cui è stato aperto il menu contestuale sul foglio
        var xPos = window.scrollX;
        var yPos = window.scrollY;
        window.onscroll = (e) => {
          window.scroll(xPos, yPos);
        };
        */


      });





    this.foglio.addEventListener("click", (e) => {

      var bounds = (e.target as any).getBoundingClientRect();

      let x = e.clientX - bounds.left + window.devicePixelRatio;
      let y = e.clientY - bounds.top + window.devicePixelRatio;


      //Da Pixel a CM
      let coordinate: ICoordinateObj = {
        x: this.convertiDaPxACm(x),
        y: this.convertiDaPxACm(y)
      };
      
      this.displayPos = `Mouse: Oriz=${coordinate.x} Vert=${coordinate.y}`;

      this.coordinateNuovoElemento = coordinate;

      //console.warn(e.target);

      if(e.ctrlKey == true && (e.target as HTMLElement).id.toLowerCase() !== 'foglio' && (e.target as HTMLElement).id.toLowerCase() !== 'areaheader' && (e.target as HTMLElement).id.toLowerCase() !== 'areafooter' && (e.target as HTMLElement).id !== 'canvasAppoggio'){

       
        if(!this.itemsSelezionati.some(item=>item.id.toString()==(e.target as HTMLElement).id.replace('bordoTrascinamento-','').replace('immagine',''))){

          let nuovoElementoSelezionato =this.itemsArray.find(item=>item.id.toString()==(e.target as HTMLElement).id.replace('bordoTrascinamento-','').replace('immagine',''));

          if(nuovoElementoSelezionato){

            this.itemsSelezionati.push(nuovoElementoSelezionato);


            if(!nuovoElementoSelezionato.tipo.includes('linea'))
              document.getElementById(nuovoElementoSelezionato.id.toString()).style.backgroundColor=this.coloreMultiselezione;
            else
              document.getElementById('bordoTrascinamento-'+nuovoElementoSelezionato.id.toString()).style.backgroundColor=this.coloreMultiselezione;
          }


        }
        else{

          this.rimuoviElementoSelezionato((e.target as HTMLElement).id.replace('bordoTrascinamento-','').replace('immagine',''));


        }


      } 
      else if ((e.target as HTMLElement).id.toLowerCase() == 'foglio' || (e.target as HTMLElement).id.toLowerCase() == 'areaheader' || (e.target as HTMLElement).id.toLowerCase() == 'areafooter' || (e.target as HTMLElement).id == 'canvasAppoggio')
      {
        this.itemSelezionato = undefined;

        if(!this.isSelectingMuliple)
        this.rimuoviElementiSelezionati();
        

        if(this.isSelectingMuliple)
          this.isSelectingMuliple=false;

      }//Controllo se è tenuto premuto il tasto ctrl e si selezionano gli items uno alla volta
       


      this.foglio.addEventListener("mousemove", this.muoviCursoreSuFoglio);


      
    });
  

    //const parser = new DOMParser();
    //let input :HTMLElement= parser.parseFromString(`<input id="palette" type="text" data-coloris >`,'text/html').getElementById("palette");



    for (let oggetto of this.menuContestualeItems[0].items) {

      oggetto.onClick = () => {

        //console.log(oggetto.text);
        //console.log(this.coordinateNuovoElemento);

        //Bisognerà aprire il dxPopup con la input avente valore dell'item cliccato


        switch ((oggetto.text as string).toLowerCase()) {

          case "testo": {
            this.formDataProprieta.tipo = "Testo";
            this.formDataProprieta.valore = "";
            this.popupProprietaVisibile = true;

          }

            break;
          case "variabile": {

            this.formDataProprieta.tipo = "Variabile";
            this.popupListaVariabili = true;


          }

            break;

          case "cornice": {


            this.formDataProprieta.tipo = "Cornice";

            this.generaCornice();


          }
            break;
          case 'immagine': {

            let input = document.createElement('input');
            input.type = 'file';
            input.style.display = 'none';
            input.multiple = false;
            input.accept = "image/png, image/jpeg, image/jpg";

            input.onchange = () => {

              var fileName = input.value;
              var idxDot = fileName.lastIndexOf(".") + 1;
              var extFile = fileName.substring(idxDot, fileName.length).toLowerCase();
              if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {

                let immagine: File = input.files[0];


                t.generaImmagine(immagine);

              } else {
                alert("Inserire solo png, jpg o jpeg!");
              }

            }

            input.click();

          } break;

          case 'linea orizzontale':{

            this.generaLinea();


          }break;

          case 'linea verticale':{

            this.generaLinea(true);


          }break;

          
          default: {

            alert("Funzione non ancora disponibile");


          } break;
        }
      }
    }

    //on click su Incolla
    this.menuContestualeItems[4].onClick=()=>{

  

      
      this.incollaElemento();


    }


    
    for (let oggetto of this.menuContestualeItemSingolo[5].items) {

      oggetto.onClick = () => {

        switch ((oggetto.text as string).toLowerCase()) {

          case 'allinea bordi superiori':{

           

            for(let i = 0; i<this.itemsSelezionati.length;i++){

              if(this.itemsSelezionati[i].id == this.itemSelezionato.id)
                continue;

              this.itemsSelezionati[i].posizione.y = this.itemSelezionato.posizione.y;
              document.getElementById(this.itemsSelezionati[i].id.toString()).style.top = this.itemSelezionato.posizione.y.toString().concat('cm');

              let indice = this.itemsArray.findIndex(item=>item.id==this.itemsSelezionati[i].id);
            
              if(indice!==-1){

                this.itemsArray[indice].posizione.y =  this.itemSelezionato.posizione.y;
                this.itemsArray = replaceObject(this.itemsArray,{id:this.itemsArray[indice].id},this.itemsArray[indice]);
              }
            }

          }break;
          case 'allinea bordi inferiori':{

          

    
            for(let i = 0; i<this.itemsSelezionati.length;i++){

              if(this.itemsSelezionati[i].id == this.itemSelezionato.id)
                continue;

              this.itemsSelezionati[i].posizione.y =this.itemSelezionato.posizione.y +(this.convertiDaPxACm(parseFloat(this.itemSelezionato.stile.altezzaContainer)) - this.convertiDaPxACm(parseFloat(this.itemsSelezionati[i].stile.altezzaContainer)));
              document.getElementById(this.itemsSelezionati[i].id.toString()).style.top = (this.itemSelezionato.posizione.y +(this.convertiDaPxACm(parseFloat(this.itemSelezionato.stile.altezzaContainer)) - this.convertiDaPxACm(parseFloat(this.itemsSelezionati[i].stile.altezzaContainer)))).toString().concat('cm')

              let indice = this.itemsArray.findIndex(item=>item.id==this.itemsSelezionati[i].id);
            
              if(indice!==-1){

                this.itemsArray[indice].posizione.y = this.itemSelezionato.posizione.y +(this.convertiDaPxACm(parseFloat(this.itemSelezionato.stile.altezzaContainer)) - this.convertiDaPxACm(parseFloat(this.itemsSelezionati[i].stile.altezzaContainer)));
                this.itemsArray = replaceObject(this.itemsArray,{id:this.itemsArray[indice].id},this.itemsArray[indice]);
              }
            }


          }break;
          case 'allinea bordi a sinistra':{


         

            for(let i = 0; i<this.itemsSelezionati.length;i++){

              if(this.itemsSelezionati[i].id == this.itemSelezionato.id)
                continue;

              this.itemsSelezionati[i].posizione.x = this.itemSelezionato.posizione.x;
              document.getElementById(this.itemsSelezionati[i].id.toString()).style.left = this.itemSelezionato.posizione.x.toString().concat('cm');

              let indice = this.itemsArray.findIndex(item=>item.id==this.itemsSelezionati[i].id);
            
              if(indice!==-1){

                this.itemsArray[indice].posizione.x =  this.itemSelezionato.posizione.x;
                this.itemsArray = replaceObject(this.itemsArray,{id:this.itemsArray[indice].id},this.itemsArray[indice]);
              }
            }

          }break;
          case 'allinea bordi a destra':{

            
           
            for(let i = 0; i<this.itemsSelezionati.length;i++){

              if(this.itemsSelezionati[i].id == this.itemSelezionato.id)
                continue;

              this.itemsSelezionati[i].posizione.x =this.itemSelezionato.posizione.x +(this.convertiDaPxACm(parseFloat(this.itemSelezionato.stile.larghezzaContainer)) - this.convertiDaPxACm(parseFloat(this.itemsSelezionati[i].stile.larghezzaContainer)));
              document.getElementById(this.itemsSelezionati[i].id.toString()).style.left = (this.itemSelezionato.posizione.x +(this.convertiDaPxACm(parseFloat(this.itemSelezionato.stile.larghezzaContainer)) - this.convertiDaPxACm(parseFloat(this.itemsSelezionati[i].stile.larghezzaContainer)))).toString().concat('cm')

              let indice = this.itemsArray.findIndex(item=>item.id==this.itemsSelezionati[i].id);
            
              if(indice!==-1){

                this.itemsArray[indice].posizione.x = this.itemSelezionato.posizione.x +(this.convertiDaPxACm(parseFloat(this.itemSelezionato.stile.larghezzaContainer)) - this.convertiDaPxACm(parseFloat(this.itemsSelezionati[i].stile.larghezzaContainer)));
                this.itemsArray = replaceObject(this.itemsArray,{id:this.itemsArray[indice].id},this.itemsArray[indice]);
              }
            }

          }break;
      
        }
      }
    }

    

    interact(`.items`).resizable({
      enabled: t.isDragging == false,
      modifiers: [
        interact.modifiers.restrict({
          restriction: 'parent',
          elementRect: { left: 0, right: 1, top: 1, bottom: 0 }
          //endOnly: true
        })
      ],
      edges: { top: false, left: false, bottom: true, right: true },
      listeners: {
        start: function (event) {

          //for(let i=0;i<document.getElementById('foglio').children.length;i++)
          //t.closeDragElement(document.getElementById('foglio').children.item(i));
          if(t.isDragging)
            return;

        },
        move: function (event) {
          /*
          let bordoTrascinamentoDaEliminare = (event.target as HTMLElement).children.item(0);
   
          if(bordoTrascinamentoDaEliminare)
            (event.target as HTMLElement).removeChild(bordoTrascinamentoDaEliminare);
         */
          if(t.isDragging)
            return;


          t.itemSelezionato = t.itemsArray.find(
            (item) => item.id == event.target.id.replace('bordoTrascinamento-', '').replace('immagine-','')
          );


          let { x, y } = event.target.dataset;

          x = (parseFloat(x) || 0) + event.deltaRect.left;
          y = (parseFloat(y) || 0) + event.deltaRect.top;

          Object.assign(event.target.style, {
            width: (t.itemSelezionato.tipo.toLowerCase() !== 'lineaverticale') ? `${event.rect.width}px` : undefined,
            height: (t.itemSelezionato.tipo.toLowerCase() == 'cornice') || (t.itemSelezionato.tipo.toLowerCase() == 'lineaverticale') || (t.itemSelezionato.tipo.toLowerCase().startsWith('immagine')) ? `${event.rect.height}px` : undefined,
            /*transform: `translate(${x}px, ${y}px)`*/
            top: (t.itemSelezionato.tipo.toLowerCase() == 'cornice') || (t.itemSelezionato.tipo.toLowerCase().startsWith('immagine')) ? `${event.target.style.top}cm` : undefined,
            left: `${event.target.style.left}cm`,
          });

          Object.assign(event.target.dataset, { x, y });

          for (let i = 0; i < t.itemsArray.length; i++) {
            if (t.itemsArray[i].id == event.target.id) {


              if(t.itemsArray[i].tipo.toLowerCase() !== 'lineaOrizzontale')
                t.itemsArray[i].stile.larghezzaContainer = (event.target as HTMLElement).offsetWidth.toFixed(2);

              if (t.itemsArray[i].tipo.toLowerCase() == 'cornice' || t.itemsArray[i].tipo.toLowerCase() == 'lineaverticale' || t.itemSelezionato.tipo.toLowerCase().startsWith('immagine'))
                t.itemsArray[i].stile.altezzaContainer = (event.target as HTMLElement).offsetHeight.toFixed(2);

                

              break;
            }
          }


        },
        end: function (event) {

          if(t.isDragging)
          return;


          let id = event.target.id;
          
          //Aggiorno le dimensioni anche degli elementi relazionati
          for(let item of t.itemsArray){
         
              if (item.id == id) {
              
                t.itemsArray = replaceObject(t.itemsArray,{id:item.id},item);
                
                break;
              }
          }
            
          //t.manipolaElementi();
        }
      }
    }).draggable({ //SOLO TRASCINAMENTO MULTIPLO (IN FASE DI TEST)
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: 'parent',
        })
      ],
      listeners: {
        move:e=>{

          
          if(!this.itemsSelezionati || this.itemsSelezionati.length==0 || !this.itemsSelezionati.some((item)=>item.id==this.itemSelezionato.id))
          return;
          
          let items = document.querySelectorAll('.items');
          
          items.forEach((item : any) => {
            
            //Se sto trascinando un item tra quelli selezionati
            let itemIndex =this.itemsSelezionati.findIndex((itemSelezionato)=>{
              return itemSelezionato.id.toString() == item.id && itemSelezionato.id.toString() !== this.itemSelezionato.id.toString()
            });

            if(itemIndex !== -1)
            {
              
              //console.log('sto trascinando elementi multipli',e);
              //var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

             const {x:dataX = '0',y:dataY = '0'} = item.dataset;

             const x = (parseFloat(dataX) || 0) + e.delta.x;
             const y = (parseFloat(dataY) || 0) + e.delta.y;
             
                   
              //e.preventDefault();
              // calculate the new cursor position:
              //pos1 = pos3 - e.clientX0;
              //pos2 = pos4 - e.clientY0;
              //pos3 = e.clientX0;
              //pos4 = e.clientY0;
              // set the element's new position:
        
        
        
        
              let larghezzaElemento = document.getElementById(item.id).offsetWidth;
              let altezzaElemento = document.getElementById(item.id).offsetHeight;
        
        
        
        
              //let x =  document.getElementById(item.id).offsetLeft + e.clientX0  //-pos1
              //let y = document.getElementById(item.id).offsetTop + e.clientY0; //-pos2
        
        
        
              let dimensioniFoglio = { //orizzontale: 794, verticale: 1123
                orizzontale: document.getElementById("foglio").offsetWidth,
                verticale: document.getElementById("foglio").offsetHeight
              }
        
        
              let xPos =   (x) + document.getElementById(item.id).offsetLeft ;
              let yPos = (y) + document.getElementById(item.id).offsetTop ;
              
              //LIMITE
              //if ((xPos>= 0 && x <= dimensioniFoglio.orizzontale - larghezzaElemento) && (yPos >= 0 && yPos <= dimensioniFoglio.verticale - altezzaElemento)) {


                let xPosInCM =  t.convertiDaPxACm(xPos);
                let yPosInCM =  t.convertiDaPxACm(yPos);
                
                try{
                  
                  this.itemsSelezionati[itemIndex].posizione.x =  xPosInCM;
                  this.itemsSelezionati[itemIndex].posizione.y =  yPosInCM;
                  
                  this.itemsArray = replaceObject(this.itemsArray,{id:this.itemsSelezionati[itemIndex].id},this.itemsSelezionati[itemIndex])
                  
                  document.getElementById(item.id).style.left = xPosInCM + "cm";
                  document.getElementById(item.id).style.top = yPosInCM + "cm";
                  
                }catch(ex){
                  console.error(ex);
                }
                
        
              }
            

            //}


          });

        }







      }


    });

    
  
  
  
  }

  /** Disegna l'area di selezione multipla nel canvas */
  inizializzaRettangoloDiSelezione(){

    let that = this;

    let canvasAppoggio = document.createElement('canvas'); //Serve per il rettangolo di selezione

    canvasAppoggio.id='canvasAppoggio';

   
   
    
    
    if(!document.getElementById('foglio').contains(document.getElementById('canvasAppoggio'))){
      
      document.getElementById('areaHeader').parentNode.insertBefore(canvasAppoggio,document.getElementById('areaHeader').nextSibling);

    }else{
      document.getElementById('foglio').removeChild(document.getElementById('canvasAppoggio'))
      document.getElementById('areaHeader').parentNode.insertBefore(canvasAppoggio,document.getElementById('areaHeader').nextSibling);

    }

    
    document.getElementById('canvasAppoggio').style.position='absolute';
    (document.getElementById('canvasAppoggio') as HTMLCanvasElement).height=document.getElementById('foglio').offsetHeight;
    (document.getElementById('canvasAppoggio') as HTMLCanvasElement).width=document.getElementById('foglio').offsetWidth;
  

    const rettangoloSelezione : CanvasRenderingContext2D= (document.getElementById('canvasAppoggio') as HTMLCanvasElement).getContext("2d");

    let origin = null;

    const render = (e) => {
      clear();
    
        
      if (origin) drawSelection(e);



    }

    (document.getElementById('canvasAppoggio') as HTMLCanvasElement).onmousedown = e => {
       
      if(e.which !== 1) //SOLO IL CLICK SINISTRO CONSENTE L'EVENTO
        return;

      origin = {x: e.offsetX, y: e.offsetY}; 
      
      
      };
    (document.getElementById('canvasAppoggio') as HTMLCanvasElement).onmouseup = e => { origin = null; render(e); };
    (document.getElementById('canvasAppoggio') as HTMLCanvasElement).onmousemove = render;

    const drawSelection = (e) => {


      this.itemsSelezionati=[];
      this.isSelectingMuliple=true;

      let larghezza : number=e.offsetX - origin.x;
      let altezza : number= e.offsetY - origin.y;

      rettangoloSelezione.strokeStyle = "#000";
      rettangoloSelezione.beginPath();
      rettangoloSelezione.rect(origin.x, origin.y,larghezza,altezza); 

      /*
      console.warn({
        x:origin.x,
        y:origin.y,
        larghezza,
        altezza
      });
      */

      rettangoloSelezione.stroke();

      let larghezzaRettangoloTotale  = this.convertiDaPxACm(larghezza) + this.convertiDaPxACm(origin.x);
      let altezzaRettangoloTotale  = this.convertiDaPxACm(altezza) + this.convertiDaPxACm(origin.y);
      let larghezzaRettangoloTotaleNegativa  = this.convertiDaPxACm(origin.x) - Math.abs(this.convertiDaPxACm(larghezza));
      let altezzaRettangoloTotaleNegativa  =  this.convertiDaPxACm(origin.y) - Math.abs(this.convertiDaPxACm(altezza));


      for(let i = 0; i<this.itemsArray.length;i++){

        //this.itemsArray[i].posizione.x > this.convertiDaPxACm(origin.x) && this.itemsArray[i].posizione.y > this.convertiDaPxACm(origin.y) && 

        let larghezzaContainerTotale  = this.convertiDaPxACm(parseFloat(this.itemsArray[i].stile.larghezzaContainer)) + (this.itemsArray[i].posizione.x);
        let altezzaContainerTotale  = this.convertiDaPxACm(parseFloat(this.itemsArray[i].stile.altezzaContainer)) + (this.itemsArray[i].posizione.y);


       

        if((larghezzaContainerTotale >= this.convertiDaPxACm(origin.x) && larghezzaContainerTotale <= larghezzaRettangoloTotale) && (altezzaContainerTotale >= this.convertiDaPxACm(origin.y) && altezzaContainerTotale <= altezzaRettangoloTotale)){ // (altezzaContainerTotale >= this.convertiDaPxACm(origin.y) && altezzaContainerTotale <= this.convertiDaPxACm(altezza)) 
          if(!this.itemsArray[i].tipo.includes('linea') && document.getElementById(this.itemsArray[i].id.toString()))
            document.getElementById(this.itemsArray[i].id.toString()).style.backgroundColor=this.coloreMultiselezione;
          else if(document.getElementById('bordoTrascinamento-'+this.itemsArray[i].id.toString()))
            document.getElementById('bordoTrascinamento-'+this.itemsArray[i].id.toString()).style.backgroundColor=this.coloreMultiselezione;
          
            this.itemsSelezionati.push(this.itemsArray[i]);

        }else if((this.convertiDaPxACm(larghezza)<0 && this.convertiDaPxACm(altezza)<0) && (larghezzaContainerTotale >= larghezzaRettangoloTotaleNegativa && larghezzaContainerTotale <= this.convertiDaPxACm(origin.x)) && (altezzaContainerTotale >= altezzaRettangoloTotaleNegativa && altezzaContainerTotale <= this.convertiDaPxACm(origin.y))){

          if(!this.itemsArray[i].tipo.includes('linea'))
            document.getElementById(this.itemsArray[i].id.toString()).style.backgroundColor=this.coloreMultiselezione;
          else
            document.getElementById('bordoTrascinamento-'+this.itemsArray[i].id.toString()).style.backgroundColor=this.coloreMultiselezione;
          
          this.itemsSelezionati.push(this.itemsArray[i]);
          //(altezzaContainerTotale >= altezzaRettangoloTotaleNegativa && altezzaContainerTotale <= this.convertiDaPxACm(origin.y))

        }
        else if((this.convertiDaPxACm(larghezza)<0 && this.convertiDaPxACm(altezza)>=0) && (larghezzaContainerTotale >= larghezzaRettangoloTotaleNegativa && larghezzaContainerTotale <= this.convertiDaPxACm(origin.x)) && (altezzaContainerTotale >= this.convertiDaPxACm(origin.y) && altezzaContainerTotale <= altezzaRettangoloTotale)){
        
          if(!this.itemsArray[i].tipo.includes('linea'))
          document.getElementById(this.itemsArray[i].id.toString()).style.backgroundColor=this.coloreMultiselezione;
        else
          document.getElementById('bordoTrascinamento-'+this.itemsArray[i].id.toString()).style.backgroundColor=this.coloreMultiselezione;
        
          this.itemsSelezionati.push(this.itemsArray[i]);
        }
        else if((this.convertiDaPxACm(larghezza)>=0 && this.convertiDaPxACm(altezza)<0) && (larghezzaContainerTotale >= this.convertiDaPxACm(origin.x) && larghezzaContainerTotale <= larghezzaRettangoloTotale) && (altezzaContainerTotale >= altezzaRettangoloTotaleNegativa && altezzaContainerTotale <= this.convertiDaPxACm(origin.y))){
        
          if(!this.itemsArray[i].tipo.includes('linea'))
            document.getElementById(this.itemsArray[i].id.toString()).style.backgroundColor=this.coloreMultiselezione;
          else
            document.getElementById('bordoTrascinamento-'+this.itemsArray[i].id.toString()).style.backgroundColor=this.coloreMultiselezione;
          
          this.itemsSelezionati.push(this.itemsArray[i]);
        
        }else{


          if(this.itemsArray[i] && document.getElementById(this.itemsArray[i].id)){

            document.getElementById(this.itemsArray[i].id).style.backgroundColor=this.itemsArray[i].stile.coloreSfondo ? this.itemsArray[i].stile.coloreSfondo  : 'transparent';
            document.getElementById('bordoTrascinamento-'+this.itemsArray[i].id).style.backgroundColor='transparent';

          }

        }



      }

      

    };




    const clear = () => {

      rettangoloSelezione.strokeStyle = "#fff";
      rettangoloSelezione.clearRect(0, 0, (document.getElementById('canvasAppoggio') as HTMLCanvasElement).width, (document.getElementById('canvasAppoggio') as HTMLCanvasElement).height);
    
    };
    
    

    /*
    
    */

  }


  rimuoviElementoSelezionato(idItem:string){

    this.isDragging = false;

    let indexItemSelezionato = this.itemsSelezionati.findIndex(
      (item)=>{
        return item.id.toString() == idItem
      }
    );

    if(indexItemSelezionato!=-1){

      let index = this.itemsArray.findIndex(
        (item)=>{
          return item.id.toString() == idItem
        }
      );


      if(!this.itemsSelezionati[index].tipo.includes('linea'))
        document.getElementById(this.itemsArray[index].id.toString()).style.backgroundColor=this.itemsArray[index].stile.coloreSfondo ? this.itemsArray[index].stile.coloreSfondo  : 'transparent';
      else
        document.getElementById('bordoTrascinamento-'+this.itemsArray[index].id.toString()).style.backgroundColor='transparent';
      
      this.itemsSelezionati.splice(indexItemSelezionato,1);

    }



  }


  rimuoviElementiSelezionati(){

    this.isDragging = false;

    //console.warn('sto rimuovendo selezionati',this.itemsSelezionati);

    if(this.itemsSelezionati.length == 0){

      let items = document.querySelectorAll('.items');
      
      items.forEach(
        (item : HTMLElement)=>{
          if(item.style.backgroundColor == this.coloreMultiselezione)
          {
            let elementoCorrispondente = this.itemsArray.find(
              (itemm)=>{
                return item.id == itemm.id
              }
            );

            //console.warn(this.itemsArray);

            if(elementoCorrispondente)
              document.getElementById(elementoCorrispondente.id).style.backgroundColor=!elementoCorrispondente.stile.coloreSfondo || elementoCorrispondente.stile.coloreSfondo.toLowerCase() == 'trasparente' ? 'transparent' : elementoCorrispondente.stile.coloreSfondo.includes(',') ? 
              `rgb(${elementoCorrispondente.stile.coloreSfondo.split(',')[0]},${elementoCorrispondente.stile.coloreSfondo.split(',')[1]},${elementoCorrispondente.stile.coloreSfondo.split(',')[2]})` : elementoCorrispondente.stile.coloreSfondo;

          }
        }
      );



    }
    else
     for(let i=0;i<this.itemsSelezionati.length;i++){


      if(!this.itemsSelezionati[i].tipo.includes('linea')){

        let index = this.itemsArray.findIndex(item=>item.id==this.itemsSelezionati[i].id);


        if(index!=-1)
         document.getElementById(this.itemsArray[index].id.toString()).style.backgroundColor=this.itemsArray[index].stile.coloreSfondo && document.getElementById(this.itemsArray[index].id.toString()).style.backgroundColor !== this.coloreMultiselezione ? this.itemsArray[index].stile.coloreSfondo  : 'transparent';

      }
      else{

        if(document.getElementById('bordoTrascinamento-'+this.itemsSelezionati[i].id.toString()))
          document.getElementById('bordoTrascinamento-'+this.itemsSelezionati[i].id.toString()).style.backgroundColor='transparent';
      }

    }

    


    this.itemsSelezionati=[];

    //this.rimuoviElementoSelezionato(document.getElementById(this.itemSelezionato.id).id.replace('bordoTrascinamento-','').replace('immagine',''));


  }

  async setLunghezzaMaxVariabile(){

    this.maxLunghezzaCaratteri = 255;/*.replace(/[#]/g,'')*/


    //console.warn(this.maxLunghezzaCaratteri);
  }
  
  async caricaVariabiliInPopup(){

    if(this.modelloDiStampaCaricato)
      if(this.modelloDiStampaCaricato.idCategoriaModello)
        this.idCategoria = this.modelloDiStampaCaricato.idCategoriaModello;

    

    let variabili = await this.modelliStampaService.getVariabili(this.idCategoria ? this.idCategoria : '100'); //
  
    let sezioni = await this.modelliStampaService.getSezioniByCategoria(this.idCategoria ? this.idCategoria : '100');


    for(let sezione of sezioni){

     
      for(let variabile of variabili){

       
        if(variabile.idSezione == sezione.id){


          variabile['group'] = sezione.descrizione;

          continue;
        }




      }


    }

    let variabiliCarichiAbbiati = this.modelliStampaService.caricaVariabiliCarichiAbbinati();

    if(variabiliCarichiAbbiati.length>0)
      variabili = variabili.concat(variabiliCarichiAbbiati);

    /*
    variabili.push({
      id:'180',
      idCategoria:'100',
      idSezione:'111',
      idFieldDTB:'ElencoProtocolliCarichiAbbinati1',
      lunghezza:11,
      descrizione:'ElencoProtocolliCarichiAbbinati1',
      allineamento:'l'
    },
    {
      id:'181',
      idCategoria:'100',
      idSezione:'111',
      idFieldDTB:'ElencoProtocolliCarichiAbbinati2',
      lunghezza:11,
      descrizione:'ElencoProtocolliCarichiAbbinati2',
      allineamento:'l'
    },
    {
      id:'182',
      idCategoria:'100',
      idSezione:'111',
      idFieldDTB:'ElencoProtocolliCarichiAbbinati3',
      lunghezza:11,
      descrizione:'ElencoProtocolliCarichiAbbinati3',
      allineamento:'l'
    },
    {
      id:'183',
      idCategoria:'100',
      idSezione:'111',
      idFieldDTB:'ElencoProtocolliCarichiAbbinati4',
      lunghezza:11,
      descrizione:'ElencoProtocolliCarichiAbbinati4',
      allineamento:'l'
    })
    */
    
  
    //console.warn(variabili);
    

    let arrayStore = new ArrayStore({
      data:variabili,
      key:'id',
    });

    this.variabiliDS = new DataSource({
      store:arrayStore,
      key:'id',
      sort:  [{ selector: "group", desc: true }],
      searchExpr:'descrizione',
      group:'group',
      searchOperation:'contains'
    });



  }


    
  


  aggiornaAltezzaHeader(evt) {

    let value = evt.value;

    if(this.stoCaricandoModello == true){
      this.stoCaricandoModello=false;
      return;
    }

    //console.log('on cambio header',evt);
    if(value == 0 && this.altezzaHeader == 0)
      return;
    
    //Nel caso stessi aumentando l'header
    if(!this.altezzaHeader || value > this.altezzaHeader){

      document.getElementById('areaHeader').style.height = `${value}cm`;
     
      //Gli elementi devono scendere quindi prendo la differenza dell'altezza attuale e quella precedente
      const differenzaAltezza = this.altezzaHeader ? (value - this.altezzaHeader) : undefined;

      for(let item of this.itemsArray){
        /*
        if(!differenzaAltezza)
          item.posizione.y += evt.value;
        else
          item.posizione.y += differenzaAltezza;
       */
        if(this.isItemInHeader(item))
          item.isInHeader = true;
        else
          item.isInHeader = false;

        if(this.isItemInFooter(item))
          item.isInFooter = true;
        else
          item.isInFooter = false;


        this.itemsArray = replaceObject(this.itemsArray,{id:item.id},item);

        document.getElementById(item.id.toString()).style.top = `${item.posizione.y}cm`;

      }

    }
    else if(value < this.altezzaHeader)
    {
      document.getElementById('areaHeader').style.height = `${value}cm`;
      
      //Gli elementi devono risalire
      //Gli elementi devono scendere quindi prendo la differenza dell'altezza attuale e quella precedente
      const differenzaAltezza = this.altezzaHeader ? (this.altezzaHeader - value) : undefined;

      for(let item of this.itemsArray){

        /*
        if(!differenzaAltezza)
        item.posizione.y -= evt.value;
        else
        item.posizione.y -= differenzaAltezza;
       */
        if(this.isItemInHeader(item))
          item.isInHeader = true;
        else
          item.isInHeader = false;

        if(this.isItemInFooter(item))
          item.isInFooter = true;
        else
          item.isInFooter = false;

        this.itemsArray = replaceObject(this.itemsArray,{id:item.id},item);

        document.getElementById(item.id.toString()).style.top = `${item.posizione.y}cm`;

      }

    }

    this.altezzaHeader = value;

  }

  aggiornaAltezzaFooter(evt) {

    let value = evt.value;


    if(this.stoCaricandoModello == true){
      this.stoCaricandoModello=false;
      return;
    }

    //document.getElementById('areaFooter').style.height = evt.component['_changedValue'] + "cm";
    //console.log('on cambio footer',evt);

    //Nel caso stessi aumentando il footer
    if(!this.altezzaFooter || value >= this.altezzaFooter){

      document.getElementById('areaFooter').style.height = `${value}cm`;
     
      //Gli elementi devono scendere quindi prendo la differenza dell'altezza attuale e quella precedente
      const differenzaAltezza = this.altezzaFooter ? (this.altezzaFooter - value) : undefined;

      for(let item of this.itemsArray){
        /*
        if(!differenzaAltezza)
          item.posizione.y += evt.value;
        else
          item.posizione.y += differenzaAltezza;
        */
        if(this.isItemInHeader(item))
          item.isInHeader = true;
        else
          item.isInHeader = false;

        if(this.isItemInFooter(item))
          item.isInFooter = true;
        else
          item.isInFooter = false;


        this.itemsArray = replaceObject(this.itemsArray,{id:item.id},item);

        //document.getElementById(item.id.toString()).style.top = `${item.posizione.y}cm`;

      }

    }
    else if(this.altezzaFooter < this.altezzaFooter)
    {
      document.getElementById('areaFooter').style.height = `${value}cm`;
      
      //Gli elementi devono risalire
      //Gli elementi devono scendere quindi prendo la differenza dell'altezza attuale e quella precedente
      const differenzaAltezza = this.altezzaFooter ? (value - this.altezzaFooter) : undefined;

      for(let item of this.itemsArray){
        /*
        if(!differenzaAltezza)
          item.posizione.y -= evt.value;
        else
          item.posizione.y -= differenzaAltezza;
      */
        if(this.isItemInHeader(item))
          item.isInHeader = true;
        else
          item.isInHeader = false;

        if(this.isItemInFooter(item))
          item.isInFooter = true;
        else
          item.isInFooter = false;


        this.itemsArray = replaceObject(this.itemsArray,{id:item.id},item);

        //document.getElementById(item.id.toString()).style.top = `${item.posizione.y}cm`;

      }

    }
  }

  onValueChangedRangeCaratteri(evt){

/*
    if(evt.start==0 && evt.end ==255)
      return;
*/

    let formdata = JSON.parse(JSON.stringify(this.formDataProprieta));


    //console.warn({inizio:evt.start,fine:evt.end});

    formdata.rangeCaratteri.inizio = evt.start;
    formdata.rangeCaratteri.fine = evt.end;
    

  

    this.formDataProprieta = formdata;

    //console.warn('onrangeChange',this.formDataProprieta);

  }



  chiudiPopupProprieta(evt) {



    this.stoModificando = false;
    this.popupProprietaVisibile = false;

    //this.resetFormData();
  }


  onKeyUpAggiornaTipo() {

    this.formDataProprieta.tipo = this.formDataProprieta.valore.length >= 1 ? `Testo (${this.formDataProprieta.valore.length} Car.)` : "Testo";

  }

  //Metodo per modificare le coordinate man mano si muove il mouse
  muoviCursoreSuFoglio(e: MouseEvent){


    if ((e.target as any).id === "foglio" || ((e.target as any).id === "areaHeader") || ((e.target as any).id === "areaFooter") || (e.target as any).id.includes('bordoTrascinamento-') || (e.target as any).className === 'items' || (e.target as any).id.includes('immagine-') ||  ((e.target as any).id === "canvasAppoggio") ){

      var bounds = this.foglio.getBoundingClientRect();

      let x = e.clientX - bounds.left;// + window.devicePixelRatio;
      let y = e.clientY - bounds.top - window.devicePixelRatio;


      //Da Pixel a CM
      let coordinate: ICoordinateObj = {
        x: this.convertiDaPxACm(x),
        y: this.convertiDaPxACm(y)
      };

      this.displayPos = `Mouse: Oriz=${coordinate.x} Vert=${coordinate.y}`;

      this.coordinateNuovoElemento = coordinate;

      if((e.target as any).id === "foglio" || ((e.target as any).id === "areaHeader") || ((e.target as any).id === "areaFooter") )
        (e.target as any).style.cursor = 'pointer';
    }

    /*
    window.onscroll = () => {
      window.scroll();
    }
    */
  }

  onMenuContestualeNascosto(evt) {
    document.getElementById('foglio').addEventListener("mousemove", this.muoviCursoreSuFoglio); //Ritorno a tracciare
  }

  async onClickImportaVariabili() {

    //console.warn(evt.selectedItems);

    let coordinateSovrapposte = 0;

    for (let data of this.dxListaVariabili.selectedItems) {

      for(let item of data.items){

        


      if((item.idFieldDTB as string).match(/(QR)|(qr)/g))
      {

        //L'immagine del QR code è inventata al momento ma solo perché serve capire dove posizionarla
        this.generaImmagine("https://upload.wikimedia.org/wikipedia/commons/7/78/Qrcode_wikipedia_fr_v2clean.png",item.idFieldDTB)

      }
      else
      {
        let fineRangeCaratteri = (item.idFieldDTB).includes('Abbinato') ? 11 : await this.modelliStampaService.getLunghezzaMassimaVariabile(item.id);     
     
        //console.warn(fineRangeCaratteri);

      const itemVariabile: ModelloStampaItem = {
        id: uuidv4(), // Math.floor(Math.random() * Date.now()),
        tipo: "variabile",
        posizione: {
          x: this.coordinateNuovoElemento.x,
          y: this.coordinateNuovoElemento.y + coordinateSovrapposte
        },
        contenuto:`${item.descrizione}#########################################################`.substring(0,fineRangeCaratteri ? fineRangeCaratteri : 255), //###${item.descrizione}###
        rangeCaratteri:/*this.formDataProprieta.rangeCaratteri ? this.formDataProprieta.rangeCaratteri :*/
        {
          inizio:0,
          fine: fineRangeCaratteri ? fineRangeCaratteri : 255
        },
        variabile: item.idFieldDTB,
        stile: {
          coloreTesto: 'black',
          grandezzaFont: 8,   //this.formDataProprieta.altezzaFont,
          stileBordo: 'solid',
          coloreSfondo: 'trasparente',
          famigliaFont: 'Courier',
          allineamento: item.allineamento.toLowerCase() == 's' ? 'l' : item.allineamento.toLowerCase() == 'c' ? 'c' : item.allineamento.toLowerCase() == 'd' ? 'r' : 'l',// (this.formDataProprieta.allineamentoFont as any),
          coloreBordo: undefined,
          aspetto: {
            bold: false,
            italic: false,
            underline: false,
            strike: false
          }
        }
      }
        
        let itemNuovo = document.createElement("pre");
        
        
        itemNuovo.innerHTML = itemVariabile.contenuto;
        
        
        itemNuovo.style.fontFamily = "Helvetica";
        
        
        itemNuovo.style.overflow = "visible";
        itemNuovo.style.position = "absolute"; //Il foglio è position relative invece
        itemNuovo.style.padding = "0px";
        itemNuovo.style.margin = "0px";
        itemNuovo.style.whiteSpace = "break-spaces";
        //itemNuovo.style.minWidth = "fit-content"; Se si vuole bloccare il itemNuovo
        //itemNuovo.style.background = "#ffffff";
        
        //itemNuovo.style.border = `2px solid ${this.formDataProprieta.coloreBordo}`;

        itemNuovo.style.top = ((this.coordinateNuovoElemento.y + coordinateSovrapposte as number)).toString().concat("cm");
        itemNuovo.style.left = ((this.coordinateNuovoElemento.x as number)).toString().concat("cm");
        
        itemNuovo.style.border = undefined;
        itemNuovo.style.borderStyle = undefined;
        itemNuovo.style.boxShadow = undefined;
        
        itemNuovo.style.color = 'black';
        itemNuovo.style.lineHeight = "unset";
        itemNuovo.style.height = "fit-content";
        itemNuovo.style.width = "fit-content";
        itemNuovo.style.fontFamily= "Courier";

        document.getElementById('foglio').appendChild(itemNuovo);
        
        itemVariabile.stile.altezzaContainer = itemNuovo.offsetHeight.toFixed(2);
        itemVariabile.stile.larghezzaContainer = itemNuovo.offsetWidth.toFixed(2);
        
        
        itemNuovo.id = itemVariabile.id.toString();
        
        itemNuovo.classList.add("items");
        
        itemNuovo.style.zIndex = '400';

        itemVariabile.rangeCaratteri.fine = fineRangeCaratteri;
        //Funziona solo per l'aggiunta di elementi per il momento non per la modifica
  
        this.itemsArray.push(itemVariabile);
  
  
        this.itemsArray = replaceObject(this.itemsArray,{id:itemVariabile.id},itemVariabile);


      }

      



      coordinateSovrapposte += 0.5;
      }
    }


    this.popupListaVariabili = false;
    this.dxListaVariabili.selectedItems = [];
    this.manipolaElementi();
  }


  onMenuContestualeItemAperto(evt) {
    
    setTimeout(
      () => {
        this.menuContestualeFoglio.instance.hide(); //Vado a nascondere il menu contestuale base del foglio
      }, 100
    );
    

      if(!this.itemSelezionato)
        return;

      if(this.itemsSelezionati.find(item=>item.id==this.itemSelezionato.id) && this.itemsSelezionati.length>1){

        this.menuContestualeItemSingolo[5]['disabled']=false;
        
      }
      else{
        
        this.menuContestualeItemSingolo[5]['disabled']=true;
        this.rimuoviElementiSelezionati();


      }

      //this.ispezionaItems(item);
    

  }

  async onAperturaPopupModelli(evt){

    await this.datagridModelliStampa.instance.refresh();

  }

  async onAperturaPopup(evt) {

    
    console.log('on apertura popup parte 1',this.itemSelezionato);

    if(this.itemSelezionato.tipo == 'variabile')
      await this.setLunghezzaMaxVariabile();
    //In questo caso specifico bisogna modificare tutti gli elementi selezionati contemporaneamente
    if(this.itemsSelezionati.length>1 && this.itemsSelezionati.some(item=>item.id==this.itemSelezionato.id)){

      //console.log('sto modificando elementi multipli',this.itemsSelezionati);

      this.formDataProprieta.valore = '';
      this.formDataProprieta.famigliaFont = 'Helvetica';
      this.formDataProprieta.altezzaFont = 9;

      this.apriTuttiForms=true;

      return;
    }
    else{

      this.apriTuttiForms=false;
      
    }

    setTimeout(
      () => {
        
        
      
        //Inizializzo il formdata

        if (this.gruppoBottoniAllineamento)
          this.gruppoBottoniAllineamento.selectedItems = [];

        if (this.stoModificando && this.itemSelezionato) {

          if (this.gruppoBottoniAllineamento && this.itemSelezionato.stile)
            switch (this.itemSelezionato.stile.allineamento as any) {

              case 'l': {
                this.gruppoBottoniAllineamento.selectedItems = [this.allineamentiFont[0]];
              } break;
              case 'c':
                this.gruppoBottoniAllineamento.selectedItems = [this.allineamentiFont[1]];
                break;
              case 'r':
                this.gruppoBottoniAllineamento.selectedItems = [this.allineamentiFont[2]];
                break;
              case 'j':
                this.gruppoBottoniAllineamento.selectedItems = [this.allineamentiFont[3]];
                break;
              default: {
                this.gruppoBottoniAllineamento.selectedItems = [this.allineamentiFont[0]];
              } break;

            }

          this.formDataProprieta.altezzaFont = this.itemSelezionato.stile.grandezzaFont;
          this.formDataProprieta.stileBordo = this.itemSelezionato.stile.stileBordo;
          this.formDataProprieta.coloreBordo = this.itemSelezionato.stile.coloreBordo;
          this.formDataProprieta.famigliaFont = this.itemSelezionato.stile.famigliaFont;

          if(this.itemSelezionato.tipo == 'variabile'){
            this.formDataProprieta.rangeCaratteri.inizio = this.itemSelezionato.rangeCaratteri.inizio;
            this.formDataProprieta.rangeCaratteri.fine = this.itemSelezionato.rangeCaratteri.fine;
          }

          if (this.itemSelezionato.stile.aspetto !== undefined && this.itemSelezionato.stile.aspetto !== null)
            for (let entry of Object.entries(this.itemSelezionato.stile.aspetto)) {

              if (entry[1] == true) {


                for (let aspetto of this.aspettiFont) {

                  if (entry[0].toLowerCase() == (aspetto.appereance as string).toLowerCase()) {




                    this.gruppoBottoniAspetto.selectedItems.push(aspetto);






                    break;
                  }

                }
              }



            }

        }



        //console.log('on apertura popup parte 2',this.formDataProprieta);


      }, 200);





  }


  onItemClickSetColoreTesto(evt) {

    //console.log(evt.itemData.options.value);

    if ((evt.itemData.options.value as string).toLowerCase() !== "trasparente") {


      this.formDataProprieta.coloreTesto = (evt.itemData.options.value as string);

      return;
    }

    else if ((evt.itemData.options.value as string).toLowerCase() === "trasparente") {



      this.formDataProprieta.coloreTesto = (evt.itemData.options.value as string);

    }


    if(this.itemsSelezionati.length>0 && this.itemsSelezionati.some(itemselezionato=>itemselezionato.id == this.itemSelezionato.id)){
      this.formDataProprieta.coloreBordo = (evt.itemData.options.value as string);
    }

  }

  onValueChangedSetColoreTesto(evt){
    
   

    this.formDataProprieta.coloreTesto = evt.target.value;

    if(this.itemsSelezionati.length>0 && this.itemsSelezionati.some(itemselezionato=>itemselezionato.id == this.itemSelezionato.id)){
      this.formDataProprieta.coloreBordo = evt.target.value;
    }

  }

  onItemClickSetColoreSfondo(evt) {
    if ((evt.itemData.options.value as string).toLowerCase() !== "trasparente") {



      this.formDataProprieta.coloreSfondo = (evt.itemData.options.value as string);

      return;
    }

    this.formDataProprieta.coloreSfondo = (evt.itemData.options.value as string);

  }


  onValueChangedSetColoreSfondo(evt){


    this.formDataProprieta.coloreSfondo = evt.target.value;



  }

  onItemClickSetColoreBordo(evt) {

    if ((evt.itemData.options.value as string).toLowerCase() !== "trasparente") {


      this.formDataProprieta.coloreBordo = (evt.itemData.options.value as string);

      return;
    }

    this.formDataProprieta.coloreBordo = (evt.itemData.options.value as string);




  }

  onValueChangedSetColoreBordo(evt){

    this.formDataProprieta.coloreBordo = evt.target.value;

  }

  onSelectionChangedSetAspetto(evt) {


    if (evt.addedItems[0]) {
      const { icon: a, appereance: aspetto, hint: c } = evt.addedItems[0];


      switch (aspetto) {

        case "bold": {
          this.formDataProprieta.aspettoFont.bold = true;
        } break;

        case "italic": {
          this.formDataProprieta.aspettoFont.italic = true;
        } break;

        case "underline": {
          this.formDataProprieta.aspettoFont.underline = true;
        } break;

        case "strike": {
          this.formDataProprieta.aspettoFont.strike = true;
        } break;


      }
    }


    if (evt.removedItems[0]) {

      const { icon: d, appereance: aspettoRimosso, hint: f } = evt.removedItems[0];


      switch (aspettoRimosso) {

        case "bold": {
          this.formDataProprieta.aspettoFont.bold = false;
        } break;

        case "italic": {
          this.formDataProprieta.aspettoFont.italic = false;
        } break;

        case "underline": {
          this.formDataProprieta.aspettoFont.underline = false;
        } break;

        case "strike": {
          this.formDataProprieta.aspettoFont.strike = false;
        } break;


      }

    }

  }



  onSelectionChangedSetAllineamento(evt) {

    if (evt.addedItems[0]) {
      const { icon: a, appereance: allineamento, hint: c } = evt.addedItems[0];

      //let allineamento = evt.addedItems[0].
      //console.log(allineamento);

      switch (allineamento as string) {

        case "left": {
          this.formDataProprieta.allineamentoFont = "l";
        } break;

        case "center": {
          this.formDataProprieta.allineamentoFont = "c";
        } break;

        case "right": {
          this.formDataProprieta.allineamentoFont = "r";
        } break;

        case "justify": {
          this.formDataProprieta.allineamentoFont = "j";
        } break;

      }
    }


  }

  generaCornice() {


    if (!this.coordinateNuovoElemento)
      return;


    let cornice = document.createElement("div");

    cornice.className = "items";
    cornice.style.width = "2cm";
    cornice.style.height = "2cm";
    cornice.style.backgroundColor = "#ffffff";
    cornice.style.border = "2px solid black";

    cornice.style.position = "absolute";


    //Per il draggin del plugin InteractJS
    //cornice.setAttribute('data-x',this.coordinateNuovoElemento.x.toString()); 
    //cornice.setAttribute('data-y',this.coordinateNuovoElemento.y.toString());






    let itemCornice: ModelloStampaItem = {
      id: uuidv4(),  //Math.floor(Math.random() * Date.now()),
      tipo: "cornice",
      posizione: {
        x: this.coordinateNuovoElemento.x,
        y: this.coordinateNuovoElemento.y
      },
      contenuto: [], //Può contenere altri items al suo interno
      stile: {
        stileBordo: 'solid',
        coloreSfondo: "#ffffff",
        coloreBordo: "black",
        altezzaContainer: '76',  //2cm in pixel
        larghezzaContainer: '76' //2cm in pixel
      }
    }

    cornice.id = itemCornice.id.toString();


    //cornice.style.transform =`translate(${(96*this.coordinateNuovoElemento.x)/2.54}px, ${(96*this.coordinateNuovoElemento.y)/2.54}px)`;
    document.getElementById('foglio').appendChild(cornice);
    cornice.style.top = this.coordinateNuovoElemento.y.toString().concat("cm");
    cornice.style.left = this.coordinateNuovoElemento.x.toString().concat("cm");


    if (this.isInHeader(true))
      itemCornice.isInHeader = true;
    else if (this.isInFooter(true))
      itemCornice.isInFooter = true;



    


    this.itemsArray.unshift(itemCornice);



    this.manipolaElementi();


    //this.itemsArrayDistinct = [...new Set(this.itemsArray)];

    
  }

  generaLinea(isVerticale?:boolean){

    if (!this.coordinateNuovoElemento)
      return;


    let linea = document.createElement("div");

    linea.className = "items";

    if(isVerticale == true){

      linea.style.width = "0cm";
      linea.style.height = "3cm"; 

    }else{

      linea.style.width = "3cm";
      linea.style.height = "0cm";

    }

    linea.style.backgroundColor = "#ffffff";
    linea.style.border = "1px solid black";

    linea.style.position = "absolute";


    //Per il draggin del plugin InteractJS
    //cornice.setAttribute('data-x',this.coordinateNuovoElemento.x.toString()); 
    //cornice.setAttribute('data-y',this.coordinateNuovoElemento.y.toString());






    let itemLinea: ModelloStampaItem = {
      id:uuidv4(),// Math.floor(Math.random() * Date.now()),
      tipo: (isVerticale == true) ? 'lineaVerticale' : 'lineaOrizzontale',
      posizione: {
        x: this.coordinateNuovoElemento.x,
        y: this.coordinateNuovoElemento.y
      },
      contenuto: undefined, //Può contenere altri items al suo interno
      stile: {
        stileBordo: 'solid',
        coloreSfondo: "#ffffff",
        coloreBordo: "black",
        altezzaContainer: (isVerticale == true) ? '113' : '0',  //3cm in px => 113 ; 0.1cm in px => 3.7
        larghezzaContainer: (isVerticale == true) ? '0' : '113' 
      }
    }

    linea.id = itemLinea.id.toString();


    //cornice.style.transform =`translate(${(96*this.coordinateNuovoElemento.x)/2.54}px, ${(96*this.coordinateNuovoElemento.y)/2.54}px)`;
    document.getElementById('foglio').appendChild(linea);
    linea.style.top = this.coordinateNuovoElemento.y.toString().concat("cm");
    linea.style.left = this.coordinateNuovoElemento.x.toString().concat("cm");


    if (this.isInHeader(true))
      itemLinea.isInHeader = true;
    else if (this.isInFooter(true))
      itemLinea.isInFooter = true;



    


    this.itemsArray.unshift(itemLinea);



    this.manipolaElementi();




  }


  generaImmagine(immagine:File | string,QRCodeVariable?:string){

    let imageElement = document.createElement('img');
    let imageDiv = document.createElement('div');
    

    imageDiv.className='items';
    

    if (immagine instanceof File) {


      let fileReader = new FileReader();
      fileReader.readAsDataURL(immagine);

      fileReader.onload = () => {
        let id = uuidv4(); //Math.floor(Math.random() * Date.now());

        let b64 = (fileReader.result as string);
        imageDiv.id=id.toString();
        imageElement.id= typeof QRCodeVariable == "string" ?  `${QRCodeVariable}-`.concat(id.toString()) : 'immagine-'.concat(id.toString());
        imageElement.src=b64;
        //imageElement.style.width='200px';
        //imageElement.style.height='200px';    
        const aspectRatio = parseFloat((imageElement.naturalWidth / imageElement.naturalHeight).toFixed(2));
        
        //imageElement.style.aspectRatio=aspectRatio.toFixed(2);
        
        imageElement.style.width = '100%';//(imageElement.height*aspectRatio)//.toFixed(2)+'px';
        imageElement.style.height = '100%';//(imageElement.width*aspectRatio)//.toFixed(2)+'px'; prima era auto
        
        imageDiv.style.position='absolute';
        imageDiv.style.top = this.coordinateNuovoElemento.y.toString().concat("cm");
        imageDiv.style.left = this.coordinateNuovoElemento.x.toString().concat("cm");

        imageDiv.style.height='76px';
        imageDiv.style.width='76px';

        imageDiv.style.border='0.5px solid black';

        

        let itemImmagine: ModelloStampaItem = {
          id:id,
          tipo: "immagine",
          posizione: {
            x: this.coordinateNuovoElemento.x,
            y: this.coordinateNuovoElemento.y
          },
          contenuto: b64, //contiene il b64 dell'immagine
          stile: {
            stileBordo: undefined,
            coloreSfondo: 'trasparente',
            coloreBordo: undefined,
            altezzaContainer:'76', // (imageElement.naturalHeight).toFixed(2),  //2cm in pixel
            larghezzaContainer:'76' //(imageElement.naturalWidth).toFixed(2) //2cm in pixel
          }
        }

        if (this.isInHeader(true))
          itemImmagine.isInHeader = true;
        else if (this.isInFooter(true))
          itemImmagine.isInFooter = true;
  
        

        this.itemsArray.unshift(itemImmagine);
        imageDiv.appendChild(imageElement);

        //imageDiv.style.width=px');
        //imageDiv.style.height=(imageElement.naturalHeight).toFixed(2).concat('px');

        imageDiv.style.zIndex = '450';

        document.getElementById('foglio').appendChild(imageDiv);


        this.manipolaElementi();
      }


    }
    else if(typeof immagine == "string"){


        let id = uuidv4(); //Math.floor(Math.random() * Date.now());

        let url = immagine;
        imageDiv.id=id.toString();
        imageElement.id= typeof QRCodeVariable == "string" ?  `${QRCodeVariable}-`.concat(id.toString()) : 'immagine-'.concat(id.toString());
        imageElement.src= url;
        //imageElement.style.width='200px';
        //imageElement.style.height='200px';    
        const aspectRatio = parseFloat((imageElement.naturalWidth / imageElement.naturalHeight).toFixed(2));
        
        //imageElement.style.aspectRatio=aspectRatio.toFixed(2);
        
        imageElement.style.width = '100%';//(imageElement.height*aspectRatio)//.toFixed(2)+'px';
        imageElement.style.height = '100%';//(imageElement.width*aspectRatio)//.toFixed(2)+'px'; prima era auto
        imageDiv.style.position='absolute';
        imageDiv.style.top = this.coordinateNuovoElemento.y.toString().concat("cm");
        imageDiv.style.left = this.coordinateNuovoElemento.x.toString().concat("cm");

        //imageDiv.style.width='2cm';

        imageDiv.style.height='76px';
        imageDiv.style.width='76px';

        imageDiv.style.border='0.5px solid black';

        

        let itemImmagine: ModelloStampaItem = {
          id:id,
          tipo: typeof QRCodeVariable == "string" ? "immagine-qr" : "immagine",
          posizione: {
            x: this.coordinateNuovoElemento.x,
            y: this.coordinateNuovoElemento.y
          },
          contenuto: immagine, //contiene l'url dell'immagine
          stile: {
            stileBordo: undefined,
            coloreSfondo: 'trasparente',
            coloreBordo: undefined,
            altezzaContainer:'76', // (imageElement.naturalHeight).toFixed(2),  //2cm in pixel
            larghezzaContainer:'76' //(imageElement.naturalWidth).toFixed(2) //2cm in pixel
          }
        }

        if (this.isInHeader(true))
          itemImmagine.isInHeader = true;
        else if (this.isInFooter(true))
          itemImmagine.isInFooter = true;
  
        

        this.itemsArray.unshift(itemImmagine);
        imageDiv.appendChild(imageElement);

        //imageDiv.style.width=px');
        //imageDiv.style.height=(imageElement.naturalHeight).toFixed(2).concat('px');


        document.getElementById('foglio').appendChild(imageDiv);


        this.manipolaElementi();

    }


  }

  isItemInHeader(item:ModelloStampaItem){

    if(!item)
      return;

      if (item.posizione.y + this.convertiDaPxACm(parseFloat(item.stile.altezzaContainer)) <= this.convertiDaPxACm(document.getElementById('areaHeader').offsetHeight)) {
        //console.warn('in header');

        return true;
      }
  }

  isItemInFooter(item:ModelloStampaItem){

    if(!item)
      return;

      if (item.posizione.y >= this.convertiDaPxACm(this.foglio.offsetHeight) - this.convertiDaPxACm(document.getElementById('areaFooter').offsetHeight) && item.posizione.y <= this.convertiDaPxACm(this.foglio.offsetHeight)) {
        //console.warn('in header');

        return true;
      }
  }

  isInHeader(isNuovoElmento:boolean){

    if (isNuovoElmento) {
      if (this.coordinateNuovoElemento.y >= 0 && this.coordinateNuovoElemento.y <= this.convertiDaPxACm(document.getElementById('areaHeader').offsetHeight)) {
        return true;
      }
    }
    else {
      if (this.itemSelezionato.posizione.y + this.convertiDaPxACm(parseFloat(this.itemSelezionato.stile.altezzaContainer)) <= this.convertiDaPxACm(document.getElementById('areaHeader').offsetHeight)) {
        //console.warn('in header');

        return true;
      }
    }

    //console.warn('non in header');

    return false;
  }


  isInFooter(isNuovoElmento: boolean) {

    if (isNuovoElmento) {
      if (this.coordinateNuovoElemento.y >= (this.convertiDaPxACm(this.foglio.offsetHeight) - this.convertiDaPxACm(document.getElementById('areaFooter').offsetHeight)) && this.coordinateNuovoElemento.y <= this.convertiDaPxACm(this.foglio.offsetHeight)) {
        return true;
      }
    } else {

      if (this.itemSelezionato.posizione.y >= this.convertiDaPxACm(this.foglio.offsetHeight) - this.convertiDaPxACm(document.getElementById('areaFooter').offsetHeight) && this.itemSelezionato.posizione.y <= this.convertiDaPxACm(this.foglio.offsetHeight))
        {
          //console.warn('in Footer');
          return true;
        
        }
    }


    return false;

  }

 
  generaTesto() {
    if (!this.coordinateNuovoElemento)
      return;


    let itemNuovo = document.createElement("pre");

    // @ts-ignore
    //$("#exampleModal").modal("show");



    itemNuovo.innerHTML = this.formDataProprieta.valore;




    //this.formDataProprieta.tipo="";




    itemNuovo.style.fontFamily = this.formDataProprieta.famigliaFont;


    //test.style.width = "fit-content";
    ///itemNuovo.style.display = "block";
    itemNuovo.style.overflow = "visible";
    itemNuovo.style.position = "absolute"; //Il foglio è position relative invece
    itemNuovo.style.padding = "0px";
    itemNuovo.style.margin = "0px";
    //itemNuovo.style.minWidth = "fit-content"; Se si vuole bloccare il itemNuovo
    itemNuovo.style.whiteSpace = "break-spaces";
    itemNuovo.style.background = "#ffffff";



    itemNuovo.style.top = ((this.coordinateNuovoElemento.y as number)).toString().concat("cm");
    itemNuovo.style.left = ((this.coordinateNuovoElemento.x as number)).toString().concat("cm");


    let item: ModelloStampaItem = {
      id:uuidv4(),  //Math.floor(Math.random() * Date.now()),
      tipo: "testo",
      contenuto: this.formDataProprieta.valore,
      posizione: {
        x: (this.coordinateNuovoElemento.x as number),
        y: (this.coordinateNuovoElemento.y as number),
      },
      stile: {
        famigliaFont: this.formDataProprieta.famigliaFont,
        grandezzaFont: this.formDataProprieta.altezzaFont,
        coloreSfondo: this.formDataProprieta.coloreSfondo ? this.formDataProprieta.coloreSfondo : 'trasparente',
        coloreTesto: this.formDataProprieta.coloreTesto.length>0 ? this.formDataProprieta.coloreTesto : 'black',
        coloreBordo: this.formDataProprieta.coloreBordo,
        stileBordo: this.formDataProprieta.stileBordo,
        allineamento: (this.formDataProprieta.allineamentoFont as any),
        aspetto: {
          bold: this.formDataProprieta.aspettoFont.bold,
          italic: this.formDataProprieta.aspettoFont.italic,
          underline: this.formDataProprieta.aspettoFont.underline,
          strike: this.formDataProprieta.aspettoFont.strike
        }
      }
    };


    itemNuovo.style.fontSize = (item.stile.grandezzaFont).toString().concat("pt");
    itemNuovo.style.backgroundColor = this.formDataProprieta.coloreSfondo;

    itemNuovo.style.border = (!item.tipo.toLowerCase().includes("testo") && !item.tipo.toLowerCase().includes("variabile")) ? (item.tipo.toLowerCase() == 'lineaverticale' || item.tipo.toLowerCase() == 'lineaorizzontale')  ? `1px solid ${this.formDataProprieta.coloreBordo}` : `2px solid ${this.formDataProprieta.coloreBordo}` : undefined;

    itemNuovo.style.borderStyle = !item.tipo.toLowerCase().includes("testo") ? (this.formDataProprieta.stileBordo.toLowerCase() == "shadow" ? "solid" : this.formDataProprieta.stileBordo) : undefined;
    itemNuovo.style.boxShadow = this.formDataProprieta.stileBordo.toLowerCase() == "shadow" ? "5px 5px #888888" : undefined;
    itemNuovo.style.zIndex = '1400';

    itemNuovo.style.color = this.formDataProprieta.coloreTesto.length>0 ? this.formDataProprieta.coloreTesto : 'black';
    //itemNuovo.style.lineHeight = "unset";



    //itemNuovo.style.width = "4cm";
    //itemNuovo.style.lineHeight = "1cm";

    //itemNuovo.setAttribute('data-x',this.coordinateNuovoElemento.x.toString());
    //itemNuovo.setAttribute('data-y',this.coordinateNuovoElemento.y.toString());


    switch (this.formDataProprieta.allineamentoFont) {

      default:
      case 'l':
        itemNuovo.style.textAlign = "left";
        break;
      case 'c': itemNuovo.style.textAlign = "center";
        break;
      case 'r': itemNuovo.style.textAlign = "right";
        break;
      case 'j': itemNuovo.style.textAlign = "justify";
        break;

    }


    for (let entry of Object.entries(this.formDataProprieta.aspettoFont)) {

      if (entry[1] == true) {
        switch (entry[0]) {

          case "bold":
            itemNuovo.style.fontWeight = "750";
            break;
          case "italic":
            itemNuovo.style.fontStyle = "italic";
            break;
          case "underline":
            itemNuovo.style.textDecoration = "underline";
            break;
          case "strike":
            itemNuovo.style.textDecoration = "line-through";
            break;
        }
      }



    }


    if (this.formDataProprieta.aspettoFont.strike && this.formDataProprieta.aspettoFont.underline) {
      itemNuovo.style.textDecoration = "underline line-through";
    }


    //Reset del formData
    this.resetFormData();






    //Funziona solo per l'aggiunta di elementi per il momento non per la modifica

    document.getElementById('foglio').appendChild(itemNuovo);

    item.stile.altezzaContainer = itemNuovo.offsetHeight.toFixed(2);
    item.stile.larghezzaContainer = itemNuovo.offsetWidth.toFixed(2);

    itemNuovo.id = item.id.toString();

    itemNuovo.classList.add("items");

    itemNuovo.style.zIndex = '1400';

    this.itemsArray.push(item);


    this.popupProprietaVisibile = false;

    //this.ispezionaItems();

    this.manipolaElementi();
  }

  //Per testo e variabili
  onSubmitProprieta(evt) {

    
    
    
    
    evt.preventDefault();
    
    let t = this;
    
    
    if (this.stoModificando) {
      //console.warn(this.formDataProprieta);
      let formData = JSON.parse(JSON.stringify(this.formDataProprieta));
      //spippos
      //Bisogna per grosse linee effettuare lo stesso processo appena sotto ma per la modifica
      
      if(this.apriTuttiForms == true){
        
        for(let item of this.itemsSelezionati){
          
          let itemRelativo = this.itemsArray.find(itemr=>itemr.id == item.id);
          
         

          let itemModdato: ModelloStampaItem = {
          id: item.id,
          tipo: item.tipo,
          contenuto: itemRelativo.tipo.toLowerCase() === 'testo' && this.formDataProprieta.valore.length>0  ? this.formDataProprieta.valore : itemRelativo.contenuto,
          posizione: {
            x: item.posizione.x,
            y: item.posizione.y
          },
          rangeCaratteri:formData.rangeCaratteri,
          stile: {
            famigliaFont: this.formDataProprieta.famigliaFont,
            grandezzaFont: this.formDataProprieta.altezzaFont,
            coloreSfondo: this.formDataProprieta.coloreSfondo, 
            coloreTesto: this.formDataProprieta.coloreTesto,
            coloreBordo: this.formDataProprieta.coloreTesto,
            stileBordo: this.formDataProprieta.stileBordo,
            
            allineamento: (this.formDataProprieta.allineamentoFont as any),
            aspetto: {
              bold: this.formDataProprieta.aspettoFont.bold,
              italic: this.formDataProprieta.aspettoFont.italic,
              underline: this.formDataProprieta.aspettoFont.underline,
              strike: this.formDataProprieta.aspettoFont.strike
            }, 
          },
        };
  
        this.updateItem(itemModdato);
        
      }
        this.resetFormData();
  
        this.popupProprietaVisibile = false;
        this.stoModificando = false;
        this.apriTuttiForms = false;
  
        return;
        
  
      }
      else
      {

      

        //console.log("NON DOVREI PASSARE QUIIIIIIIIIIIIIIII",this.formDataProprieta)
        console.warn(formData);
        

        let itemModdato: ModelloStampaItem = {
          id: this.itemSelezionato.id,
          tipo: this.itemSelezionato.tipo,
          contenuto: this.itemSelezionato.tipo.toLowerCase() == 'cornice' ? this.itemSelezionato.contenuto : this.formDataProprieta.valore,
          posizione: {
            x: this.itemSelezionato.posizione.x,
            y: this.itemSelezionato.posizione.y
          },
          rangeCaratteri:formData.rangeCaratteri,
          stile: {
            famigliaFont: this.formDataProprieta.famigliaFont,
            grandezzaFont: this.formDataProprieta.altezzaFont,
            coloreSfondo: this.formDataProprieta.coloreSfondo,
            coloreTesto: this.formDataProprieta.coloreTesto,
            coloreBordo: this.formDataProprieta.coloreBordo,
            stileBordo: this.formDataProprieta.stileBordo,
            allineamento: (this.formDataProprieta.allineamentoFont as any),
            aspetto: {
              bold: this.formDataProprieta.aspettoFont.bold,
              italic: this.formDataProprieta.aspettoFont.italic,
              underline: this.formDataProprieta.aspettoFont.underline,
              strike: this.formDataProprieta.aspettoFont.strike
            }
          }
        };
  
     
        this.updateItem(itemModdato);
  
        //Reset del formData
        this.resetFormData();
  
        this.popupProprietaVisibile = false;
        this.stoModificando = false;
  
        return;



      }



      
    }

    

    this.generaTesto();

  }

  incollaElemento(){

    if(!this.itemCopiato)
      return;

      let itemCopiatoHTMLSource =(document.getElementById(this.itemCopiato.id.toString()));

      let nuovoElementoHTML =(itemCopiatoHTMLSource.cloneNode(true) as HTMLElement);




      nuovoElementoHTML.style.top = this.coordinateNuovoElemento.y.toString().concat('cm');
      nuovoElementoHTML.style.left = this.coordinateNuovoElemento.x.toString().concat('cm');


      this.itemCopiato.posizione.y = this.coordinateNuovoElemento.y;
      this.itemCopiato.posizione.x = this.coordinateNuovoElemento.x;

      

      nuovoElementoHTML.id =  Math.floor(Math.random() * Date.now()).toString();

      
    
      
      if(nuovoElementoHTML.children.length>1){ //Nel caso ci sia un immagine oltre al bordoTrascinamento
        nuovoElementoHTML.removeChild(nuovoElementoHTML.children.item(0));
        nuovoElementoHTML.removeChild(nuovoElementoHTML.children.item(0));
      }else{

        nuovoElementoHTML.removeChild(nuovoElementoHTML.children.item(0));

      }
     

      if(this.itemCopiato.tipo.toLowerCase()=='immagine'){

        //nuovoElementoHTML.removeChild(nuovoElementoHTML.children.item(0));
    
        //document.getElementById('immagine-'+nuovoElementoHTML.id.toString()).id = 'immagine-'+nuovoElementoHTML.id.toString();
        let imgCopiatoSource = (document.getElementById('immagine-'+this.itemCopiato.id.toString()));
        
        let nuovaImgHTML =(imgCopiatoSource.cloneNode(true) as HTMLImageElement);

        nuovaImgHTML.id = 'immagine-'+nuovoElementoHTML.id;

        nuovoElementoHTML.append(nuovaImgHTML);

        
      }

      this.itemCopiato.id =nuovoElementoHTML.id;

      if(this.isInHeader(true)){
        this.itemCopiato.isInHeader = true;
        this.itemCopiato.isInFooter = false;
      }
      else if(this.isInFooter(true)){
        this.itemCopiato.isInFooter = true;
        this.itemCopiato.isInHeader = false;
      }

      this.itemsArray.unshift(this.itemCopiato);
      document.getElementById('foglio').appendChild(nuovoElementoHTML);

      setTimeout(
        () => {
          this.menuContestualeFoglio.instance.hide(); //Vado a nascondere il menu contestuale base del foglio
        }, 100
      );

      this.manipolaElementi();
    /*
      if(sourceItem.tipo.toLowerCase()=='immagine')
        document.getElementById('immagine-'+sourceItem.id.toString()).id = 'immagine-'+sourceItem.id.toString();


      //Aggiorno le posizioni relativi alla zona di paste

      sourceItem.posizione.x = this.coordinateNuovoElemento.x;
      sourceItem.posizione.y = this.coordinateNuovoElemento.y;

      document.getElementById(sourceItem.id.toString()).style.top = sourceItem.posizione.y.toString().concat('cm');
      document.getElementById(sourceItem.id.toString()).style.left = sourceItem.posizione.x.toString().concat('cm');


     
    */

      this.itemCopiato = undefined;

      this.menuContestualeItems[4]['disabled']=true;
      this.menuContestualeItemSingolo[4]['disabled']=true;
  

  }

  manipolaElementi() {

    

    let t = this;

    for (let i = 0; i < document.getElementById('foglio').children.length; i++) {

      this.manipolaElemento((document.getElementById('foglio').children.item(i)) as HTMLElement);
    }

    for(let item of this.itemsArray){

     

      if(item.tipo == 'lineaVerticale'){

        //console.log(document.getElementById(`bordoTrascinamento-${item.id}`));
        if(document.getElementById(`bordoTrascinamento-${item.id}`)){
          
          document.getElementById(`bordoTrascinamento-${item.id}`).style.width = "10px";
          document.getElementById(`bordoTrascinamento-${item.id}`).style.height = "100%";
        
        }
          
      }
      else if(item.tipo == 'lineaOrizzontale'){

        //console.log(document.getElementById(`bordoTrascinamento-${item.id}`));

        if(document.getElementById(`bordoTrascinamento-${item.id}`)){


          document.getElementById(`bordoTrascinamento-${item.id}`).style.width = "100%";
          document.getElementById(`bordoTrascinamento-${item.id}`).style.height = "10px";

        }

      }

     
    
    }
  }

  dragMultipleElements(){

    console.warn(this.itemsSelezionati);



    
  }


  //Metodo che permette il trascinamento di un item singolo
  dragElement(elmnt: HTMLElement){


    if (!elmnt)
      return;

    
  
    let t = this;


    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    if (document.getElementById("bordoTrascinamento-".concat(elmnt.id))) {
      document.getElementById("bordoTrascinamento-".concat(elmnt.id)).onmousedown = dragMouseDown;

    }

    else {
      //elmnt.onmousedown = dragMouseDown;
    }



    function dragMouseDown(e) {

      t.isDragging = true;

      
      //console.log(e.target.id);

      t.itemSelezionato = t.itemsArray.find(
        item => item.id.toString() == e.target.id.replace('bordoTrascinamento-', '').replace('immagine-','')
      );


      document.getElementById(e.target.id).style.cursor = "grabbing";
      document.getElementById(e.target.id.replace('bordoTrascinamento-','')).style.backgroundColor=t.coloreMultiselezione;


      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;

      

      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;

      document.onmouseup = closeDragElement;
    }

    function elementDrag(e) {

      if(!t.itemSelezionato)
        return;

      //console.warn('IMBECILLE');
      //document.getElementById(e.target.id).style.zIndex='500';
      
      t.isDragging = true;
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:




      let larghezzaElemento = elmnt.offsetWidth;
      let altezzaElemento = elmnt.offsetHeight;




      let x = elmnt.offsetLeft - pos1;
      let y = elmnt.offsetTop - pos2;



      let dimensioniFoglio = { //orizzontale: 794, verticale: 1123
        orizzontale: document.getElementById("foglio").offsetWidth,
        verticale: document.getElementById("foglio").offsetHeight
      }


      


      //LIMITE
      //if ((x >= 0 && x <= dimensioniFoglio.orizzontale - larghezzaElemento) && (y >= 0 && y <= dimensioniFoglio.verticale - altezzaElemento)) {
        elmnt.style.top = t.convertiDaPxACm(y) + "cm";
        elmnt.style.left = t.convertiDaPxACm(x) + "cm";

        let coordinate: ICoordinateObj = {
          x: t.convertiDaPxACm(x),
          y: t.convertiDaPxACm(y)
        }

        //console.log(t.containerAttuale);

        for (let item of t.itemsArray) {

          if (item.id.toString() === elmnt.id) {
            item.posizione = {
              x: coordinate.x,
              y: coordinate.y  //parseFloat((coordinate.y as string))+0.30 
            }

          
            break;
          }
        }
        


        //if (t.itemSelezionato.tipo.toLowerCase() !== 'cornice') {

        if(!t.itemsSelezionati || t.itemsSelezionati.length==0){

        let corniciItems = t.itemsArray.filter(
          (item) => {
            return item.tipo.toLowerCase() == 'cornice'
          });


        
        //Cornice nella quale l'elemento trascinato si trova attualmente
        let corniceContainer = corniciItems.find(
          (cornice) => {
            return (t.itemSelezionato.id !== cornice.id) && (t.itemSelezionato.posizione.y >= cornice.posizione.y && t.itemSelezionato.posizione.x >= cornice.posizione.x) && t.itemSelezionato.posizione.y + t.convertiDaPxACm(parseFloat(t.itemSelezionato.stile.altezzaContainer)) < (t.convertiDaPxACm(parseFloat(cornice.stile.altezzaContainer)) + cornice.posizione.y) && t.itemSelezionato.posizione.x + t.convertiDaPxACm(parseFloat(t.itemSelezionato.stile.larghezzaContainer)) < (t.convertiDaPxACm(parseFloat(cornice.stile.larghezzaContainer)) + cornice.posizione.x)
          });

          //console.log(corniceContainer)

        t.containerAttuale = !t.containerAttuale ? corniceContainer : t.containerAttuale;

        // aggiungere corniceContainer.id == t.containerAttuale.id per la rimozione dei duplicati durante trascinamento
        if(corniceContainer && corniceContainer.id == t.containerAttuale.id){
          //document.getElementById(t.itemSelezionato.id.toString()).style.backgroundColor='aliceblue';

          //console.log('ultimo container:',t.containerAttuale);
          //console.log('container attuale:',corniceContainer);


          t.containerAttuale = corniceContainer;

        
         


              if (!(t.containerAttuale.contenuto as any[]).some(
                (itemNidificato) => {
                  return itemNidificato.id == t.itemSelezionato.id
                }
              )) {

                

                
                //Elimina alcuni duplicati superflui
              
                for(let i = 0; i<t.itemsArray.length;i++){

                  if(t.itemsArray[i].id == t.itemSelezionato.id){

                    t.itemsArray.splice(i,1);

                  }


                }
              
                //t.zIndexIncrementale = 10; parseInt(document.getElementById(t.itemSelezionato.id.toString()).style.zIndex);
                
                //console.warn(t.containerAttuale);

                (t.containerAttuale.contenuto as any[]).push(t.itemSelezionato);
                
                document.getElementById(t.itemSelezionato.id.toString()).style.zIndex=(400+t.zIndexIncrementale).toString();

                t.zIndexIncrementale++;

                for(let item of t.itemsArray){

                  if(item.id == t.containerAttuale.id){ // && typeof item.contenuto !== 'string'

                    try{


                      t.itemsArray = insertObjectAfter(t.itemsArray,{id:item.id},t.itemSelezionato)

                    }catch(exc){

                      console.error('Errore Funzione Ricursiva: ',exc);

                      break;
                    }

                    break;
                  }

                }
                

                //t.itemsArray = replaceObject(t.itemsArray,{id:corniceContainer.id},t.itemSelezionato)
                
                

                
              }
              else{

                //console.log('mi sto muovendo nel container',t.containerAttuale.id);

                //(t.containerAttuale.contenuto as any[]) = removeObject((t.containerAttuale.contenuto as any[]),{id:t.itemSelezionato.id});
              }
            

          
        }
        else if (t.containerAttuale !== undefined && t.containerAttuale.contenuto) {


          console.warn('Container Cambiato!')

          //document.getElementById(t.itemSelezionato.id.toString()).style.backgroundColor='lightgrey';

          let indice = (t.containerAttuale.contenuto as any[]).findIndex(
            (item) => {
              return item.id == t.itemSelezionato.id
            }
          );

          if (indice != -1) {

            
            t.itemsArray = removeObject(t.itemsArray,{id:t.itemSelezionato.id});

            t.itemsArray.push(t.itemSelezionato);

          }

          t.containerAttuale = undefined;

        }
      }
        //console.log(t.itemSelezionato);

      //}
      if (!(x >= 0 && x <= dimensioniFoglio.orizzontale - larghezzaElemento) || !(y >= 0 && y <= dimensioniFoglio.verticale - altezzaElemento)) {
        document.getElementById('foglio').style.cursor = 'pointer';
      }






    }

    function valueToHex(c) {

      var hex = c.toString(16);
    
      return hex
    
    }

    function rgbToHex(r, g, b) {

      return '#'+(valueToHex(r) + valueToHex(g) + valueToHex(b));
    
    }

    function closeDragElement(e) {
      // stop moving when mouse button is released:

      //console.warn('Elemento ha terminato il trascinamento: ', e);


      let id = e.target.id;

      t.itemSelezionato = t.itemsArray.find(
        (item) => {
          return item.id == id.replace('bordoTrascinamento-', '').replace('immagine-','')
        }
      );


      
      //Se l'item droppato si trova nell' header o footer bisogna disattivare una prop e attivare l'altra, altrimenti (nel caso si trovi nell'area dei dettagli) disattivare entrambi
      
      //console.warn(t.itemSelezionato);
      
      
      if (t.itemSelezionato){

        //Questi 2 controlli sono specifici per i modelli importati da WW
        if(t.itemSelezionato.stile.coloreSfondo)
        if(t.itemSelezionato.stile.coloreSfondo.includes(',') && t.itemSelezionato.stile.coloreSfondo.split(',')){

          let valori : number[] = t.itemSelezionato.stile.coloreSfondo.split(',').map((valore)=>parseInt(valore));

          t.itemSelezionato.stile.coloreSfondo= rgbToHex(valori[0],valori[1],valori[2]);
        }

        if(t.itemSelezionato.stile.coloreBordo)
        if(t.itemSelezionato.stile.coloreBordo.includes(',') && t.itemSelezionato.stile.coloreBordo.split(',')){

          let valori : number[] = t.itemSelezionato.stile.coloreBordo.split(',').map((valore)=>parseInt(valore));

          t.itemSelezionato.stile.coloreBordo= rgbToHex(valori[0],valori[1],valori[2]);
        }


        document.getElementById(e.target.id.replace('bordoTrascinamento-','')).style.background=t.itemSelezionato.stile.coloreSfondo && t.itemSelezionato.stile.coloreSfondo !== 'transparent' && t.itemSelezionato.stile.coloreSfondo !== 'trasparente'  ? t.itemSelezionato.stile.coloreSfondo : 'transparent' ;
        document.getElementById(e.target.id.replace('bordoTrascinamento-','')).style.backgroundColor=t.itemSelezionato.stile.coloreSfondo && t.itemSelezionato.stile.coloreSfondo !== 'transparent' && t.itemSelezionato.stile.coloreSfondo !== 'trasparente'  ? t.itemSelezionato.stile.coloreSfondo : 'transparent' ;

        t.formDataProprieta.tipo = t.itemSelezionato.tipo;

        if (t.isInHeader(false)) {
          t.itemSelezionato.isInHeader = true;
          t.itemSelezionato.isInFooter = false;
        }
        else if (t.isInFooter(false)) {
          t.itemSelezionato.isInFooter = true;
          t.itemSelezionato.isInHeader = false;
        }
        else {
          t.itemSelezionato.isInFooter = false;
          t.itemSelezionato.isInHeader = false;
        }


        

      }

      if (document.getElementById(e.target.id))
        document.getElementById(e.target.id).style.cursor = "grab"

      if (document.getElementById('bordoTrascinamento-' + e.target.id))
        document.getElementById('bordoTrascinamento-' + e.target.id).style.cursor = "grab";

      if (document.getElementById('immagine-' + e.target.id))
        document.getElementById('immagine-' + e.target.id).style.cursor = "grab";

      document.getElementById('foglio').style.cursor = 'pointer';

      document.onmouseup = null;
      document.onmousemove = null;

      t.isDragging = false;

      if(!t.itemSelezionato)
        return;

      for (let i = 0; i < t.itemsArray.length; i++) {

        if (t.itemsArray[i].id.toString() == t.itemSelezionato.id.toString().replace('bordoTrascinamento-', '').replace('immagine-','')){

          t.itemsArray[i].isInHeader = t.itemSelezionato.isInHeader;
          t.itemsArray[i].isInFooter = t.itemSelezionato.isInFooter;

          //Aggiorno la posizione di eventuali items referenziati
          try{
            t.itemsArray = replaceObject(t.itemsArray,{id:t.itemsArray[i].id},t.itemsArray[i]);
          }catch(exc){

            console.error('Errore Funzione Ricursiva: ',exc);

          }finally{

            break;
          }
          //
        }

      }
    }

  }






  //Dalla Lista
  onItemClick(evt) {

    const { itemData, itemElement, itemIndex } = evt;


    let elementoCliccato: ModelloStampaItem = this.itemsArray[itemIndex];

    console.log(elementoCliccato);

    for(let item of this.itemsArray){

      if(item.tipo == 'lineaOrizzontale' || item.tipo == 'lineaVerticale')
      document.getElementById('bordoTrascinamento-'+item.id.toString()).style.backgroundColor = 'transparent';
      else
      document.getElementById(item.id.toString()).style.backgroundColor = item.stile.coloreSfondo ? item.stile.coloreSfondo : 'transparent';

    }

    if(elementoCliccato.tipo == 'lineaOrizzontale' || elementoCliccato.tipo == 'lineaVerticale')
    document.getElementById('bordoTrascinamento-'+elementoCliccato.id.toString()).style.backgroundColor = this.coloreMultiselezione;
    else
      document.getElementById(elementoCliccato.id.toString()).style.backgroundColor = this.coloreMultiselezione;
  }

 

  gestisciCRUD(evt) {

    //l'oggetto this è stato bindato con una tupla
    //console.log(evt);


    const comando: string = evt.itemData.text;

    //let itemSelezionato :ModelloStampaItem= (this as any);

    switch (comando.toLowerCase()) {

      case "elimina": {

        //console.log(this.itemSelezionato);
        if(this.itemsSelezionati.length>1 && this.itemsSelezionati.find(item=>item.id.toString() == this.itemSelezionato.id.toString())){

          //console.log('eliminazione multipla',this.itemsSelezionati);

          let itemsSelezionati = JSON.parse(JSON.stringify(this.itemsSelezionati));

          for(let itemSelezionato of itemsSelezionati)
            this.deleteItemByID(itemSelezionato.id);

        }else if(this.itemSelezionato){

          this.deleteItemByID(this.itemSelezionato.id);
        }

        //this.ispezionaItems();

        


      } break;

      case "taglia": {

        alert("Funzione ancora non disponibile");

      } break;

      case "copia": {

        if(this.itemSelezionato){
          this.itemCopiato = JSON.parse(JSON.stringify(this.itemSelezionato));
        }


        this.menuContestualeItems[4]['disabled']=false;
        this.menuContestualeItemSingolo[4]['disabled']=false;


      } break;

      case "incolla": {

       
        this.incollaElemento();

      } break;

      case "proprietà": {


        this.apriFormPerModifica(this.itemSelezionato); //Apre il form inizializzandone i valori con quelli dell'elemento selezionato

        //La modifica verrà comunque effettuata dopo il submit del form
      } break;

    }



  }




  apriFormPerModifica(itemSelezionato: ModelloStampaItem) {

    //Inizializzo il form con i dati dell'item selezionato

    console.log(itemSelezionato,this.itemSelezionato);

    if(itemSelezionato){
    

    if (itemSelezionato.tipo){

      this.formDataProprieta.tipo = itemSelezionato.tipo.toLowerCase().includes('testo') ? `Testo (${(itemSelezionato.contenuto as string).length} Car.)` : itemSelezionato.tipo;

      this.formDataProprieta.valore = itemSelezionato.tipo.toLowerCase().includes('variabile') ? itemSelezionato.variabile : itemSelezionato.tipo.toLowerCase().includes('testo') ? itemSelezionato.contenuto : undefined;

    }

    
    if (itemSelezionato.stile) {
      this.formDataProprieta.famigliaFont = itemSelezionato.stile.famigliaFont;
      this.formDataProprieta.coloreSfondo = itemSelezionato.stile.coloreSfondo;
      this.formDataProprieta.coloreTesto = itemSelezionato.stile.coloreTesto;
      this.formDataProprieta.coloreBordo = itemSelezionato.stile.coloreBordo;
      this.formDataProprieta.stileBordo = itemSelezionato.stile.stileBordo;
      this.formDataProprieta.allineamentoFont = itemSelezionato.stile.allineamento;

      if (itemSelezionato.stile.aspetto) { //Esculsivo per il testo
        this.formDataProprieta.aspettoFont.bold = itemSelezionato.stile.aspetto.bold;
        this.formDataProprieta.aspettoFont.strike = itemSelezionato.stile.aspetto.strike;
        this.formDataProprieta.aspettoFont.italic = itemSelezionato.stile.aspetto.italic;
        this.formDataProprieta.aspettoFont.underline = itemSelezionato.stile.aspetto.underline;

      }

    }

  }
    //console.log(this.formDataProprieta);

    //let tupla : [this,ModelloStampaItem] =[this,itemSelezionato];

    this.stoModificando = true;

    //Se si tratta di una cornice con all'interno un immagine in formato stringa b64
  
      if(this.itemSelezionato.tipo.toLowerCase()=='immagine'){

      let input = document.createElement('input');
      input.type = 'file';
      input.style.display = 'none';
      input.multiple = false;
      input.accept = "image/png, image/jpeg, image/jpg";

      input.onchange = () => {

        var fileName = input.value;
        var idxDot = fileName.lastIndexOf(".") + 1;
        var extFile = fileName.substring(idxDot, fileName.length).toLowerCase();
        if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {

          let immagineAggiornata : File = input.files[0];

          let fr = new FileReader();


          fr.readAsDataURL(immagineAggiornata);

          fr.onload=()=>{

            (document.getElementById('immagine-'+(this.itemSelezionato.id.toString())) as HTMLImageElement).src=(fr.result as string);

            //console.log((document.getElementById('immagine-'+(this.itemSelezionato.id.toString())) as HTMLImageElement))

           

            for(let item of this.itemsArray){

              if(item.id==this.itemSelezionato.id && item.tipo.toLowerCase()=='immagine'){

                item.contenuto = (fr.result as string);
                break;
              }

            }


          }


          

          
        } else {
          alert("Inserire solo png, jpg o jpeg!");
        }

      }

      input.click();

    }
    else
      this.popupProprietaVisibile = true;
  }

  onClickImpostaImmagineSfondo(){

    let input = document.createElement('input');
      input.type = 'file';
      input.style.display = 'none';
      input.multiple = false;
      input.accept = "image/png, image/jpeg, image/jpg";

      input.onchange = () => {

        var fileName = input.value;
        var idxDot = fileName.lastIndexOf(".") + 1;
        var extFile = fileName.substring(idxDot, fileName.length).toLowerCase();
        if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {

          let immagineAggiornata : File = input.files[0];

          let fr = new FileReader();


          fr.readAsDataURL(immagineAggiornata);

          fr.onload=()=>{

            //(document.getElementById('immagine-'+(this.itemSelezionato.id.toString())) as HTMLImageElement).src=(fr.result as string);
            //document.getElementById('foglio').style.backgroundImage = `url(${(fr.result as string)})`;
            //document.getElementById('foglio').style.backgroundSize =  'contain';

            //document.getElementById('foglio').style.backgroundSize =  undefined;
            //document.getElementById('foglio').style.backgroundPosition =  '';


            
            let imgElementPerControlloDimensione = document.createElement('img');

            //imgSfondoElement.id = 'imgSfondoElement';

            imgElementPerControlloDimensione.src = `${(fr.result as string)}`;

            //imgSfondoElement.style.width = document.getElementById('foglio').style.width;
            //imgSfondoElement.style.height = document.getElementById('foglio').style.height;


            

            if(!document.getElementById('divSfondoFoglio')){
            let divSfondoElement = document.createElement('div');

            divSfondoElement.id = 'divSfondoFoglio';

            divSfondoElement.style.backgroundImage = `url(${(fr.result as string)})`;

            divSfondoElement.style.backgroundSize = 'cover';
            divSfondoElement.style.position = 'absolute';
            divSfondoElement.style.width = '100%';
            divSfondoElement.style.height = '100%';
            divSfondoElement.style.opacity = '0.9';

            document.getElementById('areaFooter').before(divSfondoElement); //Lo inserisco prima del canvas
            
            this.immagineDiSfondoCaricata = (fr.result as string);
          }
            else{

              document.getElementById('divSfondoFoglio').style.backgroundImage = `url(${(fr.result as string)})`;

              this.immagineDiSfondoCaricata = (fr.result as string);
            }
          }
        } 
        else {
          alert("Inserire solo png, jpg o jpeg!");
        }
    }

    input.click();
  }

  
    


  onClickRimuoviImmagineSfondo(){

    if(document.getElementById('divSfondoFoglio')){

      document.getElementById('divSfondoFoglio').remove();

      this.immagineDiSfondoCaricata = undefined;

    }

  }

  onClickImportaModelloStampaWinWaste(){
confirm('Sei sicuro di voler importare il modello? Perderai le modifiche non salvate','Attenzione').then((res)=>{
  if(!res) return
 let items = JSON.parse(JSON.stringify(this.itemsArray));

    for(let item of items){

      //console.log(item);

      this.deleteItemByID(item.id);

    }

    this.zIndexIncrementale = 10;

    
    let t = this;

    let input = document.createElement('input');
    input.type = 'file';
    input.style.display = 'none';
    input.multiple = false;
    input.accept = ".json"; //application/octet-stream

    input.onchange = () => {
      var fileName = input.value;
      var idxDot = fileName.lastIndexOf(".") + 1;
      var extFile = fileName.substring(idxDot, fileName.length).toLowerCase();
      if (extFile.toLowerCase() !== "json") 
        return;

        let file : File = input.files[0];

        //console.warn(file);

        var rawFile = new XMLHttpRequest();
        rawFile.open("GET",URL.createObjectURL(file), false);
        rawFile.onreadystatechange = function ()
        {
          if(rawFile.readyState === 4)
        {
            if(rawFile.status === 200 || rawFile.status == 0)
            {

              let file = rawFile.responseText.replace(/[;]/g,',');

              console.warn(file);

                let json : any[] = JSON.parse(file);
                console.log(json);

                

                for(let i = 0 ; i < json.length ; i++){

                  switch(json[i].tipo.toLowerCase()){
                    
                    case 'cornice':
                    case 'lineaverticale':
                    case 'lineaorizzontale':
                    {
                      
                      let cornice =  document.createElement("div");
                      cornice.id = json[i].Id;
                      json[i]['id'] = json[i].Id;

                      delete json[i].Id;
                      
                      cornice.className = "items";
                      
                      
                      cornice.style.position = 'absolute';
                      
                      json[i].stile.coloreSfondo = json[i].stile.coloreSfondo.replace(/[;]/g,',');
                      json[i].stile.coloreBordo = json[i].stile.coloreBordo.replace(/[;]/g,',');
                      json[i].stile['coloreTesto'] = undefined;
                   

                      
                      if(json[i].stile.coloreSfondo == "000,000,000" && (json[i].tipo.toLowerCase() == 'lineaverticale' || json[i].tipo.toLowerCase() == 'lineaorizzontale')){
                        json[i].stile.coloreSfondo = "000,000,000";
                        json[i].stile.coloreBordo = "000,000,000";
                      }
                      else if(json[i].stile.coloreSfondo !== "000,000,000" && (json[i].tipo.toLowerCase() == 'lineaverticale' || json[i].tipo.toLowerCase() == 'lineaorizzontale')){
                        json[i].stile.coloreSfondo = json[i].stile.coloreSfondo;
                        json[i].stile.coloreBordo = json[i].stile.coloreSfondo;
                      }
                      
                      if((json[i].tipo.toLowerCase() == 'cornice') && (json[i].stile.coloreSfondo == "224,224,224"  || (i == 0 && json[i].stile.coloreSfondo == "255,255,255")))                   
                        json[i].stile.coloreSfondo = "trasparente";
                      
                      
                      

                      cornice.style.backgroundColor = `rgb(${json[i].stile.coloreSfondo ? json[i].stile.coloreSfondo: '255,255,255'})`;
                      cornice.style.border = `${json[i].tipo.toLowerCase() == 'cornice' ? '2' : '1'}px ${json[i].stile.stileBordo == 'dashed' ? 'dashed' : 'solid'} rgb(${json[i].stile.coloreBordo ? json[i].stile.coloreBordo : '0,0,0'})`;
                      

                      json[i]['rangeCaratteri'] = json[i].rangecaratteri;

                      delete json[i].rangecaratteri;

                      
                      document.getElementById('foglio').appendChild(cornice);

                      cornice.style.left = json[i].posizione.x+'cm';
                      cornice.style.top = json[i].posizione.y+'cm';

                      json[i].stile['larghezzaContainer'] = (json[i] as any).larghezzaContainer;
                      json[i].stile['altezzaContainer'] = (json[i] as any).altezzaContainer;


                      delete json[i].larghezzaContainer;
                      delete json[i].altezzaContainer;


                      if(!json[i].contenuto && json[i].tipo.toLowerCase() =='cornice')
                        json[i].contenuto = [];

                      cornice.style.width = json[i].stile.larghezzaContainer+'px';
                      cornice.style.height = json[i].stile.altezzaContainer+'px';

                      

                      t.itemsArray.unshift(json[i]);

                      t.itemsArray = replaceObject(t.itemsArray,{Id:json[i].id},json[i]);

                      //t.manipolaElementi();
                    }break;

                     
                    case 'testo':{

                      let testo = document.createElement('pre');


                      testo.id = json[i].Id;
                      json[i]['id'] = json[i].Id;

                      delete json[i].Id;
                      
                      testo.className = "items";
                      
                      
                      testo.style.position = 'absolute';
                      
                      testo.style.padding = "0px";
                      testo.style.margin = "0px";
                      //itemNuovo.style.minWidth = "fit-content"; Se si vuole bloccare il itemNuovo
                      testo.style.whiteSpace = "break-spaces";
                      
                      testo.style.zIndex = t.zIndexIncrementale.toString();

                      json[i].stile.coloreSfondo = json[i].stile.coloreSfondo.replace(/[;]/g,',');
                      json[i].stile.coloreBordo = json[i].stile.coloreBordo.replace(/[;]/g,',');
                      json[i].stile.coloreTesto =  json[i].stile.coloreTesto.replace(/[;]/g,',');


                      if(json[i].stile.coloreSfondo == "224,224,224" )                   
                        json[i].stile.coloreSfondo = "trasparente";
                      
                      if(json[i].contenuto)
                      json[i].contenuto = json[i].contenuto.replace(/[�]/g,'à');

                      testo.style.overflow = "visible";
                     

                      testo.style.backgroundColor = `rgb(${json[i].stile.coloreSfondo ? json[i].stile.coloreSfondo: '255,255,255'})`;
                      //testo.style.border = `${json[i].tipo.toLowerCase() == 'cornice' ? '2' : '1'}px solid rgb(${json[i].stile.coloreBordo ? json[i].stile.coloreBordo : '0,0,0'})`;
                      testo.style.color = `rgb(${json[i].stile.coloreTesto ? json[i].stile.coloreTesto: '255,255,255'})`;
                      testo.innerText = json[i].contenuto

                      json[i].stile.famigliaFont =json[i].stile.famigliaFont.toLowerCase().includes('courier') ? 'Courier' : json[i].stile.famigliaFont.toLowerCase().includes('arial') ? 'helvetica' : json[i].stile.famigliaFont;

                      testo.style.fontFamily = json[i].stile.famigliaFont;

                     

                      for (let entry of Object.entries(json[i].stile.aspetto)) {

                        if (entry[1] == true) {
                          switch (entry[0].toLowerCase()) {
                  
                            case "bold":
                              testo.style.fontWeight = "750";
                              break;
                            case "italic":
                              testo.style.fontStyle = "italic";
                              break;
                            case "underline":
                              testo.style.textDecoration += " underline";
                              break;
                            case "strike":
                              testo.style.textDecoration += " line-through";
                              break;
                          }
                        }
                        else {
                  
                          switch (entry[0].toLowerCase()) {
                  
                            case "bold":
                              testo.style.fontWeight = "";
                              break;
                            case "italic":
                              testo.style.fontStyle = "";
                              break;
                            case "underline":
                              testo.style.textDecoration = json[i].stile.aspetto.strike ? "line-through" : "";
                              break;
                            case "strike":
                              testo.style.textDecoration = json[i].stile.aspetto.underline ? "underline" : "";
                              break;
                          }
                  
                        }
                  
                    }

                    /*
                    let aspettoCloneObj = undefined;
                    
                    if(json[i].stile.aspetto !== null)
                    aspettoCloneObj = JSON.parse(JSON.stringify(json[i].stile.aspetto));
                  
                  

                      if(typeof aspettoCloneObj !== 'undefined')
                        (json[i] as ModelloStampaItem).stile.aspetto= {
                          bold: aspettoCloneObj.bold,
                          italic:  aspettoCloneObj.italic,
                          strike: aspettoCloneObj.strike,
                          underline: aspettoCloneObj.underline,
                        };
                      */



                      //delete json[i].stile.aspetto;

                      testo.style.fontSize = json[i].stile.grandezzaFont.toString().concat("pt");
                  

                      json[i]['rangeCaratteri'] = json[i].rangecaratteri;

                      delete json[i].rangecaratteri;

                      
                      document.getElementById('foglio').appendChild(testo);

                      json[i].posizione.y += 0.04;


                      testo.style.left = json[i].posizione.x+'cm';
                      testo.style.top = json[i].posizione.y+'cm';

                      (json[i] as ModelloStampaItem).stile.altezzaContainer =  json[i].altezzaContainer;    //testo.offsetHeight.toFixed(2);
                      (json[i] as ModelloStampaItem).stile.larghezzaContainer = json[i].larghezzaContainer;   //testo.offsetWidth.toFixed(2);
                      
                      delete json[i].larghezzaContainer;
                      delete json[i].altezzaContainer;

                      
                      //testo.style.width = json[i].stile.larghezzaContainer+'px';
                      //testo.style.height = json[i].stile.altezzaContainer+'px';



                      t.itemsArray.unshift(json[i]);

                      //Ho dovuto per una necessità fare 2 volte questa assegnazione
                      t.itemsArray = replaceObject(t.itemsArray,{Id:json[i].id},json[i]);
                      t.itemsArray = replaceObject(t.itemsArray,{id:json[i].id},json[i]);
                      

                    }break;





                  }





                }


                t.manipolaElementi();
                //correzione colori nel blocco dettagli

                

              
                
            }
        }
    }
    rawFile.send(null);



      
    }

    input.click();

})
   
  }

  /** Aggiorna l'HTML dell' item modificato */
  updateHTMLItem(itemModdato:ModelloStampaItem){
    let htmlItem =document.getElementById(itemModdato.id.toString());

    htmlItem.style.backgroundColor = itemModdato.stile.coloreSfondo.toLowerCase() != "trasparente" ? this.formDataProprieta.coloreSfondo : "";
    htmlItem.style.color = this.formDataProprieta.coloreTesto;
    
    
    if((!itemModdato.tipo.toLowerCase().includes("testo") && !itemModdato.tipo.toLowerCase().includes("variabile"))){
      
      if((this.itemsSelezionati.length>0 && this.itemsSelezionati.some(item=>item.id==this.itemSelezionato.id))){
        
        htmlItem.style.border = (itemModdato.tipo.toLowerCase() == 'lineaverticale' || itemModdato.tipo.toLowerCase() == 'lineaorizzontale')  ? `1px solid ${this.formDataProprieta.coloreTesto}` : `2px solid ${this.formDataProprieta.coloreTesto}`;
      
      }
      else
        htmlItem.style.border = (itemModdato.tipo.toLowerCase() == 'lineaverticale' || itemModdato.tipo.toLowerCase() == 'lineaorizzontale')  ? `1px solid ${this.formDataProprieta.coloreBordo}` : `2px solid ${this.formDataProprieta.coloreBordo}`;

    }
    else
      htmlItem.style.border = undefined;


    htmlItem.style.borderStyle = !itemModdato.tipo.toLowerCase().includes("testo") && !itemModdato.tipo.toLowerCase().includes("variabile") ? (this.formDataProprieta.stileBordo.toLowerCase() == "shadow" ? "solid" : this.formDataProprieta.stileBordo) : undefined;
    htmlItem.style.boxShadow = this.formDataProprieta.stileBordo.toLowerCase() == "shadow" ? "5px 5px #888888" : undefined;
    htmlItem.style.fontFamily = this.formDataProprieta.famigliaFont;

    if(this.formDataProprieta.altezzaFont)
      htmlItem.style.fontSize = this.formDataProprieta.altezzaFont.toString().concat("pt");

    if ( itemModdato.tipo.toLowerCase() === 'testo' || itemModdato.tipo.toLowerCase() === 'variabile'){

      let itemRelativo = this.itemsArray.find(itemr=>itemr.id == itemModdato.id);

      htmlItem.innerText = itemModdato.tipo.toLowerCase() === 'variabile' ?  
      
      (itemRelativo.contenuto as string).startsWith('#') ?

      `${segnaPostiVariabile.substring(itemModdato.rangeCaratteri.inizio,itemModdato.rangeCaratteri.fine)}` :

      `${(itemRelativo.contenuto as string).substring(itemModdato.rangeCaratteri.inizio,itemModdato.rangeCaratteri.fine)}` :

      itemRelativo.contenuto; //se tipo diverso da variabile
    }

    if(this.formDataProprieta.allineamentoFont)
    switch (this.formDataProprieta.allineamentoFont.toLowerCase()) {
      case 'l':
        htmlItem.style.textAlign = "left";
        break;

      case 'c':
        htmlItem.style.textAlign = "center";
        break;

      case 'r':
        htmlItem.style.textAlign = "right";
        break;

      case 'j':
        htmlItem.style.textAlign = "justify";
        break;

      default:
        htmlItem.style.textAlign = "left";
        break;
    }

    if(this.formDataProprieta.aspettoFont)
    for (let entry of Object.entries(this.formDataProprieta.aspettoFont)) {

      if (entry[1] == true) {
        switch (entry[0].toLowerCase()) {

          case "bold":
            htmlItem.style.fontWeight = "750";
            break;
          case "italic":
            htmlItem.style.fontStyle = "italic";
            break;
          case "underline":
            htmlItem.style.textDecoration += " underline";
            break;
          case "strike":
            htmlItem.style.textDecoration += " line-through";
            break;
        }
      }
      else {

        switch (entry[0].toLowerCase()) {

          case "bold":
            htmlItem.style.fontWeight = "";
            break;
          case "italic":
            htmlItem.style.fontStyle = "";
            break;
          case "underline":
            htmlItem.style.textDecoration = this.formDataProprieta.aspettoFont.strike ? "line-through" : "";
            break;
          case "strike":
            htmlItem.style.textDecoration = this.formDataProprieta.aspettoFont.underline ? "underline" : "";
            break;
        }

      }

  }
}

/** Aggiorna gli items multipli oppure quello singolarmente ispezionato */
  updateItem(itemModdato: ModelloStampaItem) {

    //Modifica elementi multipli
    if(this.apriTuttiForms == true)
    {
        
      
            for(let item of this.itemsSelezionati){

              
              let itemRelativo = this.itemsArray.find(itemr=>itemr.id == item.id);
              
                item.stile = itemModdato.stile;
  
                if(itemModdato.stile.allineamento)
                  item.stile.allineamento = itemModdato.stile.allineamento;
  
                
                item.stile.famigliaFont = itemModdato.stile.famigliaFont;
                item.stile.coloreTesto = itemModdato.stile.coloreTesto;
                item.contenuto = itemRelativo.contenuto;
  
                //console.log(itemModdato.stile.coloreTesto);
                item.stile.coloreBordo = itemModdato.stile.coloreTesto;

                
                item.stile.stileBordo = itemModdato.stile.stileBordo;
                item.stile.coloreSfondo = itemModdato.stile.coloreSfondo;
                item.rangeCaratteri = item.rangeCaratteri;
  
                this.updateHTMLItem(item);

                //Avendo aggiornato la larghezza attraverso la funzione updateHTMLItem posso procedere la calcolo delle dimensioni del container
                item.stile.altezzaContainer = document.getElementById(item.id.toString()).offsetHeight.toFixed(2);
                item.stile.larghezzaContainer = document.getElementById(item.id.toString()).offsetWidth.toFixed(2);

                //Devo aggiornare anche le proprietà delle referenze uso una libreria per aiutarmi
                try{
                  
  
                  this.itemsArray = replaceObject(this.itemsArray,{id:item.id},item);
  
                 
  
                }catch(exc){
  
                  console.error('Errore Funzione Ricursiva: ',exc);
  
                }
                finally{
  
                  continue; //SERVE PER FORZA
  
                }
  
              
            }
        
  }
  else{  
          //Modifica Item singolo
          for(let item of this.itemsArray){

            if (item.id == itemModdato.id){
              
              

              item.stile = itemModdato.stile;

              if(itemModdato.stile.allineamento)
                item.stile.allineamento = itemModdato.stile.allineamento;

              item.stile.famigliaFont = itemModdato.stile.famigliaFont;
              item.stile.coloreTesto = itemModdato.stile.coloreTesto;
              item.rangeCaratteri = itemModdato.rangeCaratteri;

              if(item.tipo.toLowerCase() == 'variabile')
                item.contenuto = (!item.variabile.toLowerCase().includes('x')) ? `${itemModdato.contenuto.replace(/[#]/g,'') + segnaPostiVariabile}`.substring(item.rangeCaratteri.inizio ? item.rangeCaratteri.inizio : 0,item.rangeCaratteri.fine ? item.rangeCaratteri.fine : 255) : itemModdato.contenuto //}#########################################################`.substring(0,fineRangeCaratteri ? fineRangeCaratteri : 255), //###${item.descrizione}###
              else
                item.contenuto = itemModdato.contenuto;

              item.stile.coloreBordo = itemModdato.stile.coloreBordo;

              item.stile.stileBordo = itemModdato.stile.stileBordo;
              item.stile.coloreSfondo = itemModdato.stile.coloreSfondo;
              item.rangeCaratteri = item.rangeCaratteri;

              this.updateHTMLItem(item);

              //Avendo aggiornato la larghezza attraverso la funzione updateHTMLItem posso procedere la calcolo delle dimensioni del container
              item.stile.altezzaContainer = document.getElementById(item.id.toString()).offsetHeight.toFixed(2);
              item.stile.larghezzaContainer = document.getElementById(item.id.toString()).offsetWidth.toFixed(2);

              //Devo aggiornare anche le proprietà delle referenze uso una libreria per aiutarmi
              try{
                

                this.itemsArray = replaceObject(this.itemsArray,{id:item.id},item);

               

              }catch(exc){

                console.error('Errore Funzione Ricursiva: ',exc);

              }
              finally{

                break;

              }

            }


          
            
          }

            
          
        }

      
    this.rimuoviElementiSelezionati();
    this.manipolaElementi();

  }




  deleteItemByID(id: string): void {

    //console.log(id); //Il problema qui è che l' id è sempre lo stesso
    


    let index = this.itemsArray.findIndex(
      function (item) {
        
        //if(item.tipo.toLowerCase()=='cornice')
         

        
        return item.id == id
      }
    );

    let indexItemSelezionato = this.itemsSelezionati.findIndex(
      function (item) {
        
        //if(item.tipo.toLowerCase()=='cornice')
          

        
        return item.id.toString() == id
      }
    );







    let elementoHTMLDaEliminare = document.getElementById(id);

    //console.warn('sto eliminando elemento:',elementoHTMLDaEliminare);
    if(elementoHTMLDaEliminare){

      if(index !== -1){


        //this.itemsArray.splice(index, 1); //vado ad eliminare l'elemento dall'array di items
        document.getElementById('foglio').removeChild(elementoHTMLDaEliminare); //Vado ad eliminare il child dal foglio
  
        this.itemsArray = removeObject(this.itemsArray,{id:id});

      }

      return;

      if(indexItemSelezionato!=-1){

        this.itemsSelezionati.splice(indexItemSelezionato,1);
        this.itemsSelezionati = removeObject(this.itemsSelezionati,{id:id});



      }
      /*
      let  rimozioneRicorsivaCornici = ( list, id ) => {
        return list.map ( item => { return {...item} }).filter ( item => {
            if ( 'contenuto' in item ) {
                item.contenuto = rimozioneRicorsiva ( item.contenuto, id );
            }
            return item.id !== id;
        });
      }

      if(isCornice)
        this.itemsArray=rimozioneRicorsivaCornici(this.itemsArray,parseInt(id));
      */


     
    }


  }




  //METODI PER LA PRODUZIONE DEL PDF







  






  /*
  sottolineaTesto(dimensioniTesto:{w:number,h:number},x:number,y:number,larghezzaContainer:number,altezzaContainer:number,testo:string){

    //Prima Riga
    this.pdf.line(x, y + dimensioniTesto.h , x + larghezzaContainer, y + dimensioniTesto.h);

    if(dimensioniTesto.w>=larghezzaContainer){



      //Seconda Riga (dovuta al wrap)
      this.pdf.line(x, y + dimensioniTesto.h+this.convertiDaPtACm(this.pdf.getLineHeightFactor()), x + larghezzaContainer, y + dimensioniTesto.h + this.convertiDaPtACm(this.pdf.getLineHeightFactor()));
    

      //per quante volte dovrò ripetere questa istruzione

      let numeroPiani = 2;

      //console.log((dimensioniTesto.h+(this.convertiDaPtACm(this.pdf.getLineHeightFactor())*numeroPiani)));
      //console.log({altezzaContainer});

      //Grandezza Font 9 di base funziona
      //console.log("grandezzaFont: " ,this.convertiDaPtACm(this.pdf.getFontSize()));
      //console.log(dimensioniTesto);
      //+(this.convertiDaPtACm(this.pdf.getLineHeightFactor())

      //console.log((this.convertiDaPtACm(this.pdf.getFontSize())*numeroPiani)-(this.convertiDaPtACm(this.pdf.getLineHeightFactor()))/100);
      //console.log(altezzaContainer);

      while(((this.convertiDaPtACm(this.pdf.getFontSize())*numeroPiani)-(this.convertiDaPtACm(this.pdf.getLineHeightFactor())) /100)<=altezzaContainer){

      
        this.pdf.line(x, y + dimensioniTesto.h+(this.convertiDaPtACm(this.pdf.getLineHeightFactor())*numeroPiani), x + larghezzaContainer, y + dimensioniTesto.h + (this.convertiDaPtACm(this.pdf.getLineHeightFactor())*numeroPiani));

        numeroPiani++;
      }
    }
  }
  */



  chiudiPopupModelli(evt){

    this.mostraPopupSalvataggioModello=false;
    this.mostraPopupModelliCaricati=false;
  }


  
  async caricaModello(idModello:number){ //GetBy

    //Salvo sia l'html sia gli items (ModelloStampaItem)
    
    //this.mostraPopupModelli=true;

    this.modelloDiStampaCaricato = await this.modelliStampaService.getModelloById(idModello);
    this.modelloDiStampaCaricato.id = idModello;
    
  
   
    
    //Svuoto i miei campi globali riferiti ai dati presente nel modello
    
    document.getElementById('foglio').innerHTML='';
    this.itemsArray=[];
    this.itemsSelezionati=[];

    setTimeout(
      ()=>{

        //Carico di nuovo il modello 

        switch(this.modelloDiStampaCaricato.formato.toLowerCase()){

          case 'a3':{

            if(this.modelloDiStampaCaricato.orientamento=='l'){
              document.getElementById('foglio').style.width='42cm'; 
              document.getElementById('foglio').style.height='29.7cm';
            }else{
              document.getElementById('foglio').style.width='29.7cm' ; 
              document.getElementById('foglio').style.height='42cm';
            }

          }break;

          case 'a4':{

            if(this.modelloDiStampaCaricato.orientamento=='l'){
              document.getElementById('foglio').style.width='29.7cm' ; 
              document.getElementById('foglio').style.height='21cm';
            }else{
              document.getElementById('foglio').style.width='21cm' ; 
              document.getElementById('foglio').style.height='29.7cm';
            }

          }break;


        }


        document.getElementById('foglio').innerHTML=this.modelloDiStampaCaricato.htmlText;
        this.itemsArray=JSON.parse(this.modelloDiStampaCaricato.json);


        for(let i = 0; i < document.getElementsByTagName('pre').length; i++){
          document.getElementsByTagName('pre').item(i).style.zIndex = '0';
        }

        /*
        sostituzione id numerici con guid 

        let items = document.querySelectorAll('.items');

        items.forEach(
          (item)=>{
            
            let index = this.itemsArray.findIndex(
              (item2)=>{
                return parseInt(item2.id) == parseInt(item.id)
              }
            );

            if(index !== -1){

              item.id = uuidv4();

              const id = this.itemsArray[index].id;

              this.itemsArray[index].id= item.id;

              this.itemsArray = replaceObject(this.itemsArray,{id:id},this.itemsArray[index]);

            }
              

          }
        );
*/


        this.inizializzaRettangoloDiSelezione();
          
        if(document.getElementById('divSfondoFoglio')){

          let bg = $('#divSfondoFoglio').css('background-image');
          bg = bg.replace('url(','').replace(')','').replace(/\"/gi, "");


          this.immagineDiSfondoCaricata=bg;
        }
        else
          this.immagineDiSfondoCaricata=undefined;

        this.zIndexIncrementale = 10;

        this.stoCaricandoModello = true;
  
        this.altezzaHeader = parseFloat(document.getElementById('areaHeader').style.height.toLowerCase().replace('cm','').replace('px',''));
        this.altezzaFooter = parseFloat(document.getElementById('areaFooter').style.height.toLowerCase().replace('cm','').replace('px',''));
     
        /*
        this.deleteItemByID('53401884030')
        this.deleteItemByID('1399523404295')
        this.deleteItemByID('1477809803286')
        */
       //this.deleteItemByID('1477809803286')

        //this.deleteItemByID('1477809803286');


        this.manipolaElementi(); //Aggiungo i bordiDiTrascinamento nuovamente

        this.chiudiPopupModelli(undefined);

        console.log(this.itemsArray);
      },500);
  }

  async rimuoviModelloDiStampa(evt){

    

    await this.modelliStampaService.rimuoviModello(evt['data']['id']);

    await this.datagridModelliStampa.instance.refresh();


    this.modelloDiStampaCaricato = undefined;


  }

  //Aggiunto dalla apposita Datagrid
  async aggiungiModelloDiStampa(evt){

    //console.log(evt);

    const innerHTML: string =document.getElementById('foglio').innerHTML;
    const itemsSalvati: string = JSON.stringify(this.itemsArray);

    let nuovoModello : IModelloStampa={  
      nomeModello:evt['data']['nomeModello'],
      idCategoriaModello:evt['data']['idCategoriaModello'],
      htmlText:innerHTML,
      json:itemsSalvati,
      formato:evt['data']['formato'],
      orientamento:evt['data']['orientamento'],
    };

    let ris = await this.modelliStampaService.aggiungiModello(nuovoModello);

    //this.modelloDiStampaCaricato = ris;

    this.modelliDiStampaDS = await this.modelliStampaService.getModelli();

    

    await this.datagridModelliStampa.instance.refresh();


    await this.caricaModello(ris.id);

    notify({
      message: `Modello di Stampa '${this.modelloDiStampaCaricato.nomeModello}' aggiunto con successo!`,
      position: {
          my: "center bottom",
          at: "center bottom"
      }
    }, "success", 3000);
  
    //this.modelliDiStampaDS.push(nuovoModello);

    this.mostraPopupSalvataggioModello=false
  }

  async emettiEventoPulsante(evt){
    
   
    
    switch(evt){
    
      case 'salvaModello':{

        if(!this.modelloDiStampaCaricato)
          return;
        //console.warn(this.formSalvataggioModello.dataSet);

        await this.onClickAggiornaModello();

        }break;

      }
  }
  


  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }


  chiudiFileManagerPopup(evt) {
    this.fileManagerVisibile = false;


  }


  async onClickGeneraPDF(){

    if(this.modelloDiStampaCaricato && this.modelloDiStampaCaricato.idCategoriaModello)
      this.dataTable = await this.modelliStampaService.getMockData(this.modelloDiStampaCaricato.idCategoriaModello as Categorie);
    else
      this.dataTable = await this.modelliStampaService.getMockData(Categorie.MOVIMENTI);

    
    if(!this.modelloDiStampaCaricato){

      this.modelloDiStampaCaricato ={
        htmlText:undefined,
        json:undefined,
        formato:undefined,
        nomeModello:undefined,
        idCategoriaModello:Categorie.MOVIMENTI,
        id:0,
        orientamento:undefined
      }


    }

    this.modelloDiStampaCaricato.htmlText = document.getElementById('foglio').innerHTML;
    this.modelloDiStampaCaricato.json = JSON.stringify(this.itemsArray);



    let id = await this.modelliStampaService.generaPDF(this.dataTable,this.modelloDiStampaCaricato,'preview');

    /*
    setTimeout(()=>{
      
      if((document.querySelectorAll('[class="modal popup"]').item(0) as HTMLElement))
        (document.querySelectorAll('[class="modal popup"]').item(0) as HTMLElement).style.zIndex = '99999999999999';

    },100);
    */
    if(id){
      
      this.componentService.outputComponent.subscribe(currentOutput => {
        if (currentOutput.guid == id) {
          //console.log('currentOutput--->', currentOutput)
          if (currentOutput.name == "close") {
            this.componentService.destroyCurrentOpenPopUpByGuid(id);
            this.componentService.destroyOutputComponent();
            this.refreshPage([], '', this.SubjectCall, this.template)
          }
        }
      })
      
    }
    /* const componentGr = 'NicaDataGridComponent'

    const instanceData = {
      service: 'movimentiRifiutoRegistri',
      api: '',
      dataSource: res,
      remoteOperation: false,
      queryString: '',
      isEditable: false,
      isEditableNewRow: false,
      isEditableEditRow: false,
      isEditableDeleteRow: false,
      isOdata: false,
      showToolbarTop: false,
      tableHeight: 380,
      tableWidth: 1355,
      showFilter: false,
      selectionRowMode: null,  // 'single' | 'detail' | 'multiple';
      idTable: 'listaMovimentiProtocollati',
      isSearchable: false,

    }

    this.openComponentInPopUP(componentGr, [], instanceData, '1355', 'Anteprima movimenti protocollati', true, true) */
  }


  /**
   * Scarica il file in formato JSON
   */
  async onClickDownloadJSON(){

    const innerHTML: string =document.getElementById('foglio').innerHTML;
    const itemsSalvati: string = JSON.stringify(this.itemsArray);

    let modelloDiStampa : IModelloStampa={
      nomeModello:this.modelloDiStampaCaricato.nomeModello, //this.formSalvataggioModello.dataSet['nomeModello'],
      idCategoriaModello:this.modelloDiStampaCaricato.idCategoriaModello,   //this.formSalvataggioModello.dataSet['categoriaModello'][this.formSalvataggioModello.dataSet['categoriaModello'].length-1]['id'],
      htmlText:innerHTML,
      json:itemsSalvati,
      formato:this.modelloDiStampaCaricato.formato,   //this.formSalvataggioModello.dataSet['formato'],
      orientamento:this.modelloDiStampaCaricato.orientamento,   //this.formSalvataggioModello.dataSet['orientamento'],
      guidCreazione:this.modelloDiStampaCaricato.guidCreazione
    }; 


    const fileToDownload = new Blob([JSON.stringify(modelloDiStampa)],{type:'application/json'});

    
    saveAs(fileToDownload,`${modelloDiStampa.nomeModello}.json`);

  }


  async onClickControllaVariabiliSenzaContainer(){

    await this.modelliStampaService.mostraVariabileOrfane(this.itemsArray);
    
  }





}




/*
        case 'c':{

          let testina : string | number= parseFloat(item.stile.larghezzaContainer)/2;

          testina = this.convertiDaPxACm(parseFloat(testina.toString())); //Passo la testina di scrittura in cm

          testina =parseFloat(xCM) + parseFloat(testina) - (dimensioniTesto.w/2);

          

          //Se il testo allineato al centro viene wrappato
          if(parseFloat(larghezzaContainerInCM)<=dimensioniTesto.w){ 
            

            
 

          }
          else{
            pdf.text(item.contenuto,testina,(yCM as unknown as number),{maxWidth:parseFloat(larghezzaContainerInCM),lineHeightFactor:1.35});
          }
          

        }break;



      if(item.stile.aspetto.strike){

        let asseY = (yCM as unknown as number)-parseFloat(`0.${item.stile.grandezzaFont <= 9 ? "0".concat(item.stile.grandezzaFont.toString()) : item.stile.grandezzaFont}`);

        
        pdf.line(parseFloat(item.posizione.x as string),asseY,parseFloat(item.posizione.x as string)+0.02+dimensioniTesto.w,asseY);

      }


*/




